export const locales = ["ar", "fr"] as const;
export type Locale = (typeof locales)[number];

export const ar = {
  "app.brand": "Chams.Pay",
  "app.placeholderBrand": "إدارة الأداءات المدرسية",
  "app.phase": "إدارة مدرسية",
  "pwa.installTitle": "ثبّت Chams.Pay على هاتفك",
  "pwa.installBody": "استخدم Chams.Pay كتطبيق مستقل مع وصول أسرع وتجربة أفضل للعمل دون اتصال.",
  "pwa.installIosBody": "اضغط على زر المشاركة، ثم اختر «إضافة إلى الشاشة الرئيسية» لتثبيت التطبيق.",
  "pwa.installManualBody":
    "افتح قائمة المتصفح واختر «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية».",
  "pwa.installAction": "تثبيت التطبيق",
  "pwa.installUnderstood": "حسنًا",
  "pwa.installLater": "لاحقًا",
  "pwa.pullToRefresh": "اسحب أكثر للتحديث",
  "pwa.refreshing": "جارٍ تحديث المحتوى",
  "mobile.backToExit": "اضغط على رجوع مرة أخرى للخروج",
  "mobile.chooseStudent": "اختر تلميذاً لبدء تسجيل الأداء",
  "mobile.downloadStarted": "بدأ تنزيل الملف",
  "mobile.contentRefreshed": "تم تحديث المحتوى",
  "mobile.copied": "تم النسخ",
  "mobile.studentCreated": "تم إنشاء التلميذ",
  "mobile.studentUpdated": "تم تحديث بيانات التلميذ",
  "mobile.serviceAmountsUpdated": "تم تحديث واجبات الخدمات",
  "mobile.lifecycleUpdated": "تم تحديث وضعية التلميذ",
  "mobile.paymentRecorded": "تم تسجيل الأداء",
  "mobile.instrumentSettled": "تم تأكيد التحصيل",
  "mobile.instrumentRejected": "تم رفض الأداة",
  "mobile.paymentCancelled": "تم إلغاء الأداء",
  "mobile.settingsSaved": "تم حفظ الإعدادات",
  "mobile.rolloverCompleted": "اكتمل الانتقال إلى الموسم المقبل",
  "mobile.installationApproved": "تمت الموافقة على الجهاز",
  "mobile.installationRejected": "تم رفض الجهاز",
  "mobile.installationRevoked": "تم إلغاء ترخيص الجهاز",
  "mobile.accessCodeIssued": "تم إصدار رمز الولوج",
  "mobile.syncCompleted": "اكتملت المزامنة",
  "auth.eyebrow": "Chams.Pay",
  "auth.title": "تسجيل الدخول",
  "auth.description": "ادخل إلى Chams.Pay باستخدام مفتاح المرور.",
  "auth.identifier": "معرّف المستخدم",
  "auth.identifierHint": "أدخل معرف حسابك.",
  "auth.signIn": "تسجيل الدخول",
  "auth.enroll": "تسجيل مفتاح مرور",
  "auth.enrollmentCode": "رمز التسجيل أو الاسترداد",
  "auth.useCode": "متابعة التسجيل",
  "auth.codeHint": "يصدره مدير النظام ويُستخدم مرة واحدة خلال 30 دقيقة.",
  "auth.error": "تعذّر التحقق. راجع البيانات وحاول بأمان.",
  "auth.enrolled": "تم تسجيل مفتاح المرور. يمكنك الآن تسجيل الدخول.",
  "auth.synthetic": "دخول آمن",
  "installation.eyebrow": "هذا الجهاز",
  "installation.title": "ربط الجهاز",
  "installation.description": "سجّل هذا الجهاز ثم اطلب ترخيصه من مدير النظام.",
  "installation.register": "تسجيل الجهاز",
  "installation.authorize": "ترخيص الجهاز",
  "installation.pending": "الجهاز مسجل وينتظر الترخيص.",
  "installation.pendingHelp":
    "يجب أن يرخّص مدير النظام هذا الجهاز قبل أن يتمكن المسؤول المالي من الدخول.",
  "installation.adminSignIn": "تسجيل الدخول كمدير للنظام",
  "installation.authorized": "التثبيت مرخّص",
  "installation.deviceCode": "رمز الجهاز",
  "offline.setupTitle": "إعداد العمل دون اتصال",
  "offline.setupDescription": "اختر رمزاً من 8 أرقام لفتح التطبيق عند غياب الاتصال.",
  "offline.pin": "رمز من 8 أرقام",
  "offline.prepare": "إعداد التطبيق",
  "offline.lockedTitle": "التطبيق مقفل",
  "offline.lockedDescription": "أدخل الرمز لفتح التطبيق.",
  "offline.unlock": "فتح التطبيق",
  "offline.invalidPin": "رمز PIN غير صحيح. تم تطبيق تأخير أمني دون حذف البيانات.",
  "offline.blocked": "يلزم إعادة ترخيص عبر الإنترنت بعد 10 محاولات. لم تُحذف البيانات.",
  "offline.corrupt": "تعذّر التحقق من النسخة المشفرة. تم حظر القراءة ولم تُمسح البيانات.",
  "offline.freshness": "آخر مزامنة",
  "offline.freshnessShort": "آخر مزامنة",
  "offline.statusOnline": "متصل",
  "offline.statusOffline": "دون اتصال",
  "offline.localMode": "العمل دون اتصال",
  "offline.onlineMode": "متصل",
  "offline.sync": "مزامنة الآن",
  "offline.onlineOnly": "يلزم الاتصال لإتمام المزامنة.",
  "sync.unsynchronized": "عمليات في الانتظار",
  "sync.ready": "جاهز",
  "sync.warning24": "مرّ أكثر من 24 ساعة على آخر مزامنة",
  "sync.warning72": "تحذير: مرّت أكثر من 72 ساعة على آخر مزامنة",
  "sync.blocked": "يلزم إجراء المزامنة قبل تسجيل أداء جديد",
  "sync.queued": "في الانتظار",
  "sync.syncing": "جارٍ الإرسال",
  "sync.synced": "متزامن",
  "sync.failed": "تعذّرت المزامنة. ستتم إعادة المحاولة تلقائياً.",
  "sync.rejected": "تحتاج عملية إلى مراجعة مدير النظام.",
  "nav.students": "التلاميذ",
  "nav.access": "المستخدمون والأجهزة",
  "nav.settings": "الإعدادات",
  "nav.lock": "قفل",
  "nav.signOut": "تسجيل الخروج",
  "students.search": "البحث عن تلميذ",
  "students.searchPlaceholder": "الاسم، STU-0001 أو MASSAR",
  "students.results": "نتائج البحث",
  "students.noResults": "لا توجد نتائج مطابقة",
  "students.class": "المستوى",
  "students.services": "الخدمات الحالية",
  "students.serviceTuition": "الدراسة",
  "students.serviceTransport": "النقل",
  "students.serviceAccompaniment": "المرافقة",
  "students.profile": "ملف التلميذ",
  "students.back": "العودة إلى النتائج",
  "students.birthDate": "تاريخ الميلاد",
  "students.guardian": "الولي الرئيسي",
  "students.enrollment": "التسجيل الحالي",
  "students.academicYear": "السنة الدراسية",
  "students.enrolledAt": "تاريخ التسجيل",
  "students.obligations": "الواجبات",
  "students.total": "إجمالي السنة",
  "students.outstanding": "المتبقي",
  "students.overdue": "استحقاقات متأخرة",
  "students.register": "تسجيل تلميذ",
  "students.edit": "تعديل التلميذ",
  "students.save": "حفظ",
  "students.nameAr": "الاسم بالعربية",
  "students.nameFr": "الاسم بالفرنسية",
  "students.massar": "رمز MASSAR",
  "students.guardianName": "اسم الولي الرئيسي",
  "students.guardianPhone": "هاتف الولي",
  "students.transport": "النقل",
  "students.accompaniment": "المرافقة",
  "students.formDescription": "أدخل هوية التلميذ وبيانات تسجيله.",
  "students.duplicate": "يوجد تلميذ بهذه البيانات. راجع MASSAR قبل الحفظ.",
  "students.saveFailed": "تعذّر حفظ التلميذ. راجع الحقول وحاول مرة أخرى.",
  "students.saved": "تم حفظ بيانات التلميذ.",
  "students.selectForPayment": "ابحث عن التلميذ لبدء الأداء.",
  "students.showAllObligations": "عرض كل الواجبات",
  "students.noPayments": "لا توجد أداءات مسجلة.",
  "students.mutationDeferred": "تعديل التلميذ غير متاح في المرحلة 01",
  "admin.title": "إصدار رمز أحادي الاستخدام",
  "admin.description": "يُستخدم الرمز مرة واحدة خلال 30 دقيقة.",
  "admin.user": "المستخدم",
  "admin.purpose": "الغرض",
  "admin.enrollment": "تسجيل",
  "admin.recovery": "استرداد",
  "admin.issue": "إصدار الرمز",
  "admin.issued": "انسخ الرمز الآن؛ لن يظهر مرة أخرى.",
  "profile.title": "الحساب",
  "profile.role": "الصلاحية",
  "profile.systemAdministrator": "مدير النظام",
  "profile.financialAdministrator": "المسؤول المالي",
  "profile.syncTitle": "المزامنة",
  "profile.lastSync": "آخر مزامنة",
  "profile.pendingCount": "عمليات في الانتظار",
  "profile.synchronized": "تمت المزامنة",
  "profile.offline": "دون اتصال",
  "profile.syncing": "جارٍ إجراء المزامنة",
  "profile.details": "تفاصيل",
  "settings.title": "الإعدادات",
  "settings.account": "الحساب",
  "settings.accountDescription": "بيانات الحساب والصلاحية الحالية.",
  "settings.usersDevices": "المستخدمون والأجهزة",
  "settings.systemStatus": "حالة النظام",
  "settings.systemStatusDescription": "حالة الخدمات اللازمة للعمل.",
  "settings.service": "خدمة التطبيق",
  "settings.background": "المهام الخلفية",
  "settings.available": "متاحة",
  "settings.unavailable": "غير متاحة",
  "settings.backToStudents": "العودة إلى التلاميذ",
  "settings.schoolSettings": "إعدادات المؤسسة",
  "settings.schoolIdentity": "بيانات المؤسسة",
  "settings.schoolNameAr": "اسم المؤسسة بالعربية",
  "settings.schoolNameFr": "اسم المؤسسة بالفرنسية",
  "settings.schoolEmail": "البريد الإلكتروني",
  "settings.schoolPhone": "هاتف المؤسسة",
  "settings.addressAr": "العنوان بالعربية",
  "settings.addressFr": "العنوان بالفرنسية",
  "settings.financialSettings": "تعريفة الموسم الدراسي الحالي",
  "settings.preschoolRegistration": "واجب التسجيل — التعليم الأولي",
  "settings.primaryRegistration": "واجب التسجيل — التعليم الابتدائي",
  "settings.preschoolTuition": "التمدرس الشهري — التعليم الأولي",
  "settings.primaryTuition": "التمدرس الشهري — التعليم الابتدائي",
  "settings.transportFee": "النقل الشهري",
  "settings.accompanimentFee": "المرافقة الشهرية",
  "settings.prospectiveFees":
    "تُطبّق هذه التعريفة على الواجبات الجديدة للموسم الحالي. لا تتغير الواجبات أو الأداءات السابقة.",
  "settings.classes": "المستويات والانتقال",
  "settings.classLabel": "المستوى",
  "settings.cycle": "السلك",
  "settings.preschool": "التعليم الأولي",
  "settings.primary": "التعليم الابتدائي",
  "settings.nextClass": "المستوى في الموسم المقبل",
  "settings.addClass": "إضافة مستوى",
  "settings.removeClass": "حذف المستوى",
  "settings.saveGlobal": "حفظ الإعدادات العامة",
  "settings.saveFees": "حفظ التعريفات",
  "settings.saved": "تم حفظ الإعدادات العامة.",
  "settings.loadFailed": "تعذر تحميل إعدادات المؤسسة.",
  "settings.academicYear": "الموسم الدراسي",
  "settings.currentSchoolYear": "الموسم الحالي",
  "settings.nextSchoolYear": "الموسم المقبل",
  "settings.advanceYear": "فتح الأداء المسبق للموسم المقبل",
  "settings.advanceYearHelp":
    "راجع تعريفة الموسم المقبل قبل إنشاء واجباته. نُسخت القيم مبدئياً من تعريفة الموسم الحالي.",
  "settings.advanceYearActiveHelp":
    "تعريفة الموسم المقبل مجمّدة، ويمكن تحصيل أداءاته دون تغيير تسجيل الموسم الحالي.",
  "settings.advanceYearWarning":
    "يُنشئ هذا الإجراء واجبات الموسم المقبل لجميع التلاميذ النشطين المؤهلين، باستثناء المستويات النهائية. لا يمكن تغيير التعريفة بعد التأكيد.",
  "settings.advanceYearConfirm": "راجعت تعريفة الموسم المقبل وأؤكد فتح الأداء المسبق.",
  "settings.advanceYearAction": "فتح الأداء المسبق للموسم المقبل",
  "settings.advanceYearActive": "تم فتح الأداء المسبق للموسم المقبل.",
  "settings.studentsEligible": "تلميذاً مؤهلاً",
  "settings.advanceYearDialogTitle": "تأكيد فتح الأداء المسبق",
  "settings.advanceYearDialogBody":
    "راجع الموسم والتعريفات وعدد التلاميذ. سيُجمّد هذا الإجراء التعريفة وينشئ الواجبات في عملية واحدة.",
  "settings.advanceYearDialogConfirm": "تأكيد وفتح الأداء المسبق",
  "settings.advanceYearActivating": "جارٍ فتح الأداء المسبق…",
  "settings.advanceYearActionFailed":
    "تعذر تأكيد فتح الأداء المسبق. تحققنا من الحالة الحالية ويمكنك إعادة المحاولة بأمان.",
  "settings.rollover": "الانتقال إلى الموسم المقبل",
  "settings.rolloverHelp":
    "ينقل جميع التلاميذ وخدماتهم إلى أقسام الموسم المقبل، وينشئ واجباته بالتعريفة الحالية. يمتد الموسم من شتنبر إلى يوليوز.",
  "settings.rolloverWarning":
    "عملية واحدة عامة لا يمكن التراجع عنها. الأداءات والواجبات السابقة تبقى محفوظة دون تعديل.",
  "settings.rolloverConfirm": "راجعت التعريفة وأؤكد الانتقال العام إلى الموسم المقبل.",
  "settings.rolloverAction": "تمرير الجميع إلى الموسم المقبل",
  "settings.rolloverDialogTitle": "تأكيد الانتقال العام",
  "settings.rolloverDialogBody":
    "سيتم تمرير جميع التلاميذ والخدمات وإنشاء واجبات الموسم المقبل. لا يمكن التراجع عن هذه العملية.",
  "settings.rolloverDialogCancel": "الرجوع",
  "settings.rolloverDialogConfirm": "تأكيد الانتقال",
  "settings.rolloverComplete": "اكتمل الانتقال إلى الموسم المقبل.",
  "settings.studentsAdvanced": "تلميذاً تم تمريره",
  "settings.obligationsCreated": "واجباً جديداً",
  "update.ready": "تحديث التطبيق",
  "update.blocked": "سيبدأ التحديث بعد انتهاء المزامنة الجارية.",
  "language.arabic": "العربية",
  "language.french": "Français",
  "login.eyebrow": "بوابة الإدارة المالية",
  "login.title": "وضوح في كل عملية، حتى قبل أن يبدأ العمل المالي.",
  "login.description":
    "هذه معاينة اصطناعية لهيكل التطبيق المتصل. تسجيل الدخول الآمن والمستخدمون الحقيقيون مؤجلون للمرحلة 01.",
  "login.previewNotice": "دخول محلي اصطناعي فقط · ليس مصادقة إنتاجية",
  "login.previewAction": "فتح المعاينة الاصطناعية",
  "login.productionUnavailable": "المصادقة الإنتاجية غير مفعّلة في المرحلة 00",
  "login.foundationLabel": "واجهة ثنائية اللغة ومتّصلة بقاعدة البيانات",
  "nav.status": "حالة النظام",
  "nav.foundation": "دليل الواجهة",
  "shell.preview": "معاينة محلية اصطناعية",
  "shell.role": "مسؤول مالي اصطناعي",
  "shell.title": "التلاميذ",
  "shell.subtitle": "أساس مرئي ومتصل للمرحلة 00",
  "connectivity.online": "متصل بالإنترنت",
  "connectivity.offline": "غير متصل",
  "status.eyebrow": "فحص مباشر",
  "status.title": "حالة بنية التطبيق",
  "status.description":
    "تأتي هذه البيانات من Fastify بعد استعلام PostgreSQL والتحقق من نبض العامل الخلفي.",
  "status.loading": "جارٍ فحص قاعدة البيانات والعامل…",
  "status.ready": "كل مكونات المعاينة جاهزة",
  "status.degraded": "الخدمة متاحة لكن العامل الخلفي غير جاهز",
  "status.error": "تعذّر الوصول إلى حالة النظام",
  "status.unavailable": "الخدمة غير متاحة مؤقتاً",
  "status.retry": "إعادة المحاولة",
  "status.database": "PostgreSQL",
  "status.migrations": "الترحيلات",
  "status.worker": "العامل الخلفي",
  "status.dataset": "بيانات اصطناعية",
  "status.connected": "متصلة",
  "status.active": "نشط",
  "status.seeded": "مهيأة",
  "status.checked": "آخر فحص",
  "foundation.eyebrow": "لغة الواجهة",
  "foundation.title": "نظام واحد، واتجاهان متكافئان",
  "foundation.description":
    "تُبنى العربية من اليمين إلى اليسار أولاً، وتبقى الفرنسية مكافئة من اليسار إلى اليمين، مع أرقام غربية وعزل واضح للمراجع المختلطة.",
  "foundation.reference": "مرجع تجريبي",
  "foundation.date": "تاريخ العرض",
  "foundation.amount": "مبلغ تجريبي",
  "foundation.states": "حالات الواجهة الأساسية",
  "state.empty": "لا توجد إشعارات حالياً",
  "state.emptyHelp": "ستظهر الحالات التشغيلية هنا في المراحل اللاحقة.",
  "state.loading": "جارٍ التحميل",
  "state.error": "حدث خطأ يمكن استرداده",
  "state.unavailable": "الإجراء غير متاح دون اتصال",
  "state.recovery": "يلزم التحقق قبل المتابعة",
  "state.recoveryHelp": "تُحفظ الأدلة ولا تُحذف عند الحاجة إلى الاسترداد.",
  "common.ready": "جاهز",
  "common.notReady": "غير جاهز",
  "common.close": "إغلاق",
  "entry.schoolName": "مؤسسة شمس العلوم",
  "entry.studentsWord": "تلميذاً",
  "entry.heroTitle": "إدارة واجبات التمدرس، بهدوء ووضوح.",
  "entry.heroBody": "تسجيل الأداءات، متابعة المتأخرات، وإصدار الوصولات — حتى بدون اتصال بالإنترنت.",
  "entry.heroStatus": "الخدمة تعمل بشكل طبيعي",
  "entry.tabLogin": "الدخول بمفتاح المرور",
  "entry.tabRegister": "تسجيل مفتاح جديد",
  "entry.signinTitleIdle": "مرحباً بعودتك",
  "entry.signinSubIdle": "استعمل مفتاح المرور الخاص بهذا الجهاز للدخول.",
  "entry.signinTitleSubmit": "جارٍ التحقّق…",
  "entry.signinSubSubmit": "أكمِل التحقّق على جهازك.",
  "entry.signinTitleErr": "تعذّر الدخول",
  "entry.signinSubErr": "لم يتم التعرّف على مفتاح المرور.",
  "entry.enrollTitleIdle": "تسجيل مفتاح مرور جديد",
  "entry.enrollSubIdle": "أدخل الرمز المؤقّت، ثم أكمِل إنشاء المفتاح على جهازك.",
  "entry.enrollTitleSubmit": "جارٍ تسجيل المفتاح…",
  "entry.enrollSubSubmit": "أكمِل إنشاء مفتاح المرور على جهازك.",
  "entry.enrollTitleErr": "تعذّر تسجيل المفتاح",
  "entry.enrollSubErr": "لم يكتمل إنشاء مفتاح المرور. لم يُستعمل الرمز المؤقّت.",
  "entry.username": "اسم المستخدم",
  "entry.passkeyTitle": "التحقّق بمفتاح المرور",
  "entry.passkeyBody": "بصمة أو رمز الجهاز. لا توجد كلمة سر تُحفظ.",
  "entry.signinErrTitle": "مفتاح المرور غير معروف على هذا الجهاز",
  "entry.signinErrBody": "سجّل مفتاحاً جديداً برمز مؤقّت، أو اطلب من المدير إعادة التصريح.",
  "entry.enrollErrTitle": "لم يتم تسجيل مفتاح المرور",
  "entry.enrollErrBody":
    "تحقّق من صلاحية الرمز المؤقّت ثم حاول مجدداً. لا يُستعمل الرمز إلا بعد نجاح التسجيل.",
  "entry.enrollErrCompatibleBody":
    "لم يُستعمل الرمز المؤقّت. أعد المحاولة بتسجيل متوافق مع هذا الجهاز؛ سيبقى الدخول دون اتصال متاحاً برمز PIN.",
  "entry.btnIdle": "الدخول بمفتاح المرور",
  "entry.btnSubmit": "جارٍ التحقّق…",
  "entry.btnErr": "إعادة المحاولة",
  "entry.useOffline": "الدخول بدون اتصال (رمز PIN)",
  "entry.oneTimeCode": "الرمز المؤقّت",
  "entry.codeHint": "رمز يمنحه لك مدير النظام، يُستعمل مرّة واحدة وصالح 30 دقيقة.",
  "entry.registerPasskey": "تسجيل مفتاح المرور",
  "entry.enrollBtnSubmit": "جارٍ تسجيل المفتاح…",
  "entry.enrollRetry": "إعادة محاولة التسجيل",
  "entry.enrollRetryCompatible": "إعادة المحاولة بتسجيل متوافق",
  "entry.existingPasskeyTitle": "مفتاح المرور مسجّل بالفعل على هذا الجهاز",
  "entry.existingPasskeyBody":
    "يعرض Windows Hello مفاتيح المرور لكل ملفات المتصفح. تم الانتقال إلى تسجيل الدخول ووُضع اسم المستخدم الصحيح؛ لم يُستعمل الرمز المؤقّت.",
  "entry.onlineSessionRequiredTitle": "يلزم تجديد جلسة الإنترنت",
  "entry.onlineSessionRequiredBody":
    "انتهت جلسة الخادم. سجّل الدخول مجدداً لتحميل لوحة القيادة والجداول والتقارير.",
  "entry.serverUnreachableTitle": "تعذّر الوصول إلى الخادم",
  "entry.serverUnreachableBody":
    "فُتحت النسخة المحلية بأمان، لكن تعذّر الاتصال بالخادم. أعد المحاولة أو سجّل الدخول عبر الإنترنت.",
  "entry.sessionRestoringTitle": "جارٍ استعادة جلسة الخادم",
  "entry.sessionRestoringBody": "تبقى النسخة المحلية متاحة أثناء التحقق من الجلسة عبر الإنترنت.",
  "entry.regDoneTitle": "تم تسجيل مفتاح المرور",
  "entry.regDoneBody": "يمكنك الآن الدخول من هذا الجهاز مباشرة.",
  "entry.dev1Title": "هذا المتصفّح غير مسجّل",
  "entry.dev1Body": "لأسباب أمنية، كل متصفّح يجب أن يُسجّل ثم يوافق عليه مدير النظام قبل استعماله.",
  "entry.deviceFingerprint": "بصمة الجهاز",
  "entry.registerDevice": "تسجيل هذا الجهاز",
  "entry.dev2Title": "في انتظار موافقة المدير",
  "entry.dev2Body":
    "تم إرسال الطلب. ستُفتح الجلسة تلقائياً بمجرّد الموافقة — لا حاجة لإعادة التحميل.",
  "entry.requestSent": "أُرسل الطلب",
  "entry.checkAgain": "التحقّق الآن",
  "entry.dev3Title": "طلب تصريح بجهاز جديد",
  "entry.dev3Body":
    "راجع بصمة الجهاز وصاحب الطلب قبل الموافقة. يمكن سحب التصريح في أي وقت من الإعدادات.",
  "entry.requester": "صاحب الطلب",
  "entry.approve": "الموافقة",
  "entry.reject": "رفض",
  "entry.dev4Title": "تعذّر تسجيل الجهاز",
  "entry.dev4Body":
    "تعذّر إتمام تسجيل هذا الجهاز. أعد المحاولة، أو اتصل بمدير النظام إن تكرّر الأمر.",
  "entry.dev4Detail": "تعذّر التسجيل",
  "entry.retry": "إعادة المحاولة",
  "entry.contactAdmin": "الاتصال بالمدير",
  "entry.pinSetupTitle": "تهيئة العمل بدون اتصال",
  "entry.pinSetupSub": "رمز من 8 أرقام",
  "entry.pinSetupBody":
    "هذا الرمز يفتح النسخة المحلية المشفّرة عندما لا يوجد اتصال. لا يمكن استرجاعه — في حال نسيانه تُعاد التهيئة عبر الإنترنت.",
  "entry.pinNew": "الرمز الجديد",
  "entry.pinConfirm": "تأكيد الرمز",
  "entry.pinShow": "إظهار الرمز",
  "entry.pinHide": "إخفاء الرمز",
  "entry.pinRule1": "ثمانية أرقام",
  "entry.pinRule2": "لا أرقام متسلسلة أو متكرّرة",
  "entry.pinSave": "حفظ وتحضير النسخة المحلية",
  "entry.pinMismatch": "الرمزان غير متطابقين",
  "entry.pinMismatchBody": "أعد إدخال التأكيد.",
  "entry.pinPreparing": "جارٍ تحضير النسخة المحلية",
  "entry.lockedTitle": "التطبيق مقفل",
  "entry.lockSubIdle": "أدخل رمز PIN للدخول.",
  "entry.lockSubWrong": "رمز غير صحيح. حاول مرّة أخرى.",
  "entry.wrongPin": "رمز غير صحيح",
  "entry.usePasskey": "فتح بالبصمة أو مفتاح المرور",
  "entry.attemptsLeft": "3 محاولات متبقية",
  "entry.signInOnline": "الدخول عبر الإنترنت بدل ذلك",
  "entry.useAnotherAccount": "استخدام حساب آخر",
  "entry.lockoutTitle": "تم إيقاف الدخول بدون اتصال",
  "entry.lockoutBody":
    "بعد عشر محاولات خاطئة، يتطلّب فتح التطبيق دخولاً عبر الإنترنت وموافقة جديدة على الجهاز. لم تُحذف أي بيانات.",
  "entry.failedAttempts": "محاولات خاطئة",
  "entry.corruptTitle": "النسخة المحلية غير سليمة",
  "entry.corruptBody":
    "تعذّر التحقّق من سلامة البيانات المحلية. لم تُفقد أي عملية أداء: الأداءات غير المرسلة محفوظة في طابور منفصل.",
  "entry.rebuildCopy": "إعادة بناء النسخة المحلية",
  "dash.schoolName": "مؤسسة شمس العلوم",
  "dash.workspace": "مساحة العمل",
  "dash.nav1": "لوحة المتابعة",
  "dash.nav2": "التلاميذ",
  "dash.nav3": "الشيكات والتحويلات",
  "dash.tab3": "شيكات",
  "dash.nav4": "التقارير",
  "dash.nav5": "الإعدادات",
  "dash.adminOnly": "مدير",
  "dash.dashTitle": "لوحة المتابعة",
  "dash.dashSub": "الموسم الدراسي 2025 – 2026",
  "dash.obligationMonth": "شهر الاستحقاق",
  "dash.monthLabel": "مارس 2026",
  "dash.range": "مدة",
  "dash.activityPeriod": "فترة النشاط",
  "dash.periodWeek": "هذا الأسبوع",
  "dash.periodMonth": "هذا الشهر",
  "dash.periodAcademicYear": "الموسم الدراسي",
  "dash.periodCustom": "أو اختر فترة",
  "dash.year": "الموسم",
  "dash.takePayment": "تسجيل أداء",
  "dash.collectionRate": "نسبة التحصيل",
  "dash.expected": "المتوقع",
  "dash.selectedPeriod": "الفترة المختارة",
  "dash.currentSituation": "الوضع الحالي",
  "dash.overdueReceivables": "المبالغ المتأخرة",
  "dash.activityCollections": "التحصيلات",
  "dash.noCollectionsForPeriod": "لا توجد تحصيلات خلال هذه الفترة",
  "dash.academicCollection": "التحصيل حسب شهر الاستحقاق",
  "dash.academicCollectionSub": "المتوقع مقابل المحصّل",
  "dash.attentionQueue": "يتطلب المتابعة",
  "dash.urgentAttention": "متأخرات لشهرين أو أكثر",
  "dash.registrationAttention": "تسجيلات غير مؤداة",
  "dash.oldestPending": "أقدم عملية في الانتظار",
  "dash.noExpected": "لا توجد مبالغ متوقعة",
  "dash.studentsWord": "تلميذاً",
  "dash.vsLastMonth": "عن الشهر الماضي",
  "dash.netIncome": "صافي المداخيل",
  "dash.monthToDate": "منذ بداية الشهر",
  "dash.mad": "درهم",
  "dash.gross": "الإجمالي",
  "dash.cancellations": "الملغاة",
  "dash.net": "الصافي",
  "dash.urgentArrears": "متأخرات عاجلة",
  "dash.arrearsAmount": "المبلغ المتأخر",
  "dash.viewList": "عرض القائمة",
  "dash.pendingInstruments": "شيكات وتحويلات في انتظار التحصيل",
  "dash.pendingAmount": "المبلغ في انتظار التحصيل",
  "dash.cheques": "شيكات",
  "dash.transfers": "تحويلات",
  "dash.trendTitle": "تطوّر التحصيل",
  "dash.trendSub": "نسبة التحصيل شهرياً",
  "dash.incomeBreakdown": "تركيبة المداخيل",
  "dash.lateRegistrations": "تسجيلات متأخرة",
  "dash.arrearsByMonths": "المتأخرات حسب عدد الأشهر",
  "dash.arrearsSub": "كل رقم يفتح قائمة التلاميذ المعنيين",
  "dash.openStudents": "فتح قائمة التلاميذ",
  "dash.oneMonth": "شهر واحد",
  "dash.twoMonths": "شهران",
  "dash.threePlus": "ثلاثة أشهر أو أكثر",
  "dash.captureReadiness": "جاهزية التسجيل",
  "dash.ok": "سليمة",
  "dash.readinessNote":
    "يمكن تسجيل الأداءات. تُنبَّه بعد 72 ساعة بدون مزامنة، ويتوقّف التسجيل بعد سبعة أيام.",
  "dash.userRole": "مسؤولة مالية",
  "dash.online": "متصل",
  "dash.offline": "غير متصل",
  "dash.lastSync": "آخر مزامنة",
  "dash.pendingPayments": "أداءات في الانتظار",
  "dash.localCopy": "النسخة المحلية",
  "dash.syncNow": "مزامنة الآن",
  "dash.readinessWarn": "مرّت أكثر من 72 ساعة بدون مزامنة. يتوقّف تسجيل الأداءات بعد سبعة أيام.",
  "dash.lock": "قفل التطبيق",
  "dash.signOut": "تسجيل الخروج",
  "dash.retry": "إعادة المحاولة",
  "dash.unavailable": "غير متوفّر",
  "dash.offlineTitle": "الأرقام غير متوفّرة بدون اتصال",
  "dash.offlineBody":
    "المؤشرات تُحسب على الخادم. يمكنك مواصلة تسجيل الأداءات، وسترسل تلقائياً عند عودة الاتصال.",
  "dash.offlineActions": "ما يمكنك فعله الآن",
  "dash.failedTitle": "تعذّر تحميل بعض المؤشرات",
  "dash.failedBody": "انتهت مدة الاتصال بالخادم. الأرقام المعروضة قد تكون قديمة.",
  "dash.blocked": "التسجيل موقوف",
  "dash.blockedTitle": "تسجيل الأداءات موقوف — المزامنة مطلوبة",
  "dash.blockedBody":
    "مرّت أكثر من سبعة أيام بدون مزامنة. لا يمكن تسجيل أداءات جديدة حتى تكتمل المزامنة.",
  "dash.storageBlockedTitle": "تسجيل الأداءات موقوف — التخزين الآمن مطلوب",
  "dash.storageBlockedBody":
    "لم يمنح المتصفح التخزين الدائم بعد. ثبّت التطبيق أو اسمح بتخزين بيانات الموقع، ثم أعد المزامنة.",
  "dash.clockBlockedTitle": "تسجيل الأداءات موقوف — يجب التحقق من الساعة",
  "dash.clockBlockedBody":
    "تعذّر التحقق من توقيت هذا الجهاز. فعّل التاريخ والوقت التلقائيين، ثم أعد المزامنة.",
  "dash.blockedHint": "أكمل المزامنة لاستعادة تسجيل الأداءات.",
  "dash.m1": "أكتوبر",
  "dash.m2": "نونبر",
  "dash.m3": "دجنبر",
  "dash.m4": "يناير",
  "dash.m5": "فبراير",
  "dash.m6": "مارس",
  "dash.m7": "أبريل",
  "sp.schoolName": "مؤسسة شمس العلوم",
  "sp.students": "التلاميذ",
  "sp.enrolled": "تلميذاً مسجّلاً",
  "sp.summaryCount": "العدد",
  "sp.summaryStudent": "تلميذ",
  "sp.summaryStudents": "تلاميذ",
  "sp.summarySearch": "البحث",
  "sp.summaryLevel": "المستوى",
  "sp.summaryStatus": "الحالة",
  "sp.summaryPayment": "الأداء",
  "sp.summaryLate": "التأخر",
  "sp.summaryArrears": "متأخرات",
  "sp.summaryTwoPlusMonths": "شهران أو أكثر",
  "sp.summaryRegistrationUnpaid": "رسوم التسجيل غير المؤداة",
  "sp.searchValue": "سامي",
  "sp.searchHint": "الاسم · STU · MASSAR",
  "sp.registerStudent": "تسجيل تلميذ",
  "sp.clearSearch": "مسح البحث",
  "sp.filters": "تصفية",
  "sp.filterAll": "الكل",
  "sp.clearFilters": "إعادة تعيين جميع عوامل التصفية",
  "sp.filterArrears": "متأخرات فقط",
  "sp.filterClass": "+ المستوى",
  "sp.filterService": "+ الخدمات",
  "sp.results": "نتائج",
  "sp.class": "المستوى",
  "sp.section": "القسم",
  "sp.reference": "المرجع الداخلي",
  "sp.monthsLate": "أشهر متأخرة",
  "sp.monthLate": "شهر متأخر",
  "sp.upToDate": "منتظم",
  "sp.newlyEnrolled": "تسجيل جديد",
  "sp.emptyTitle": "لا نتائج",
  "sp.emptyBody": "تحقّق من الاسم أو رقم MASSAR، أو سجّل تلميذاً جديداً.",
  "sp.filteredEmptyBody": "لا يوجد تلاميذ يطابقون عوامل التصفية الحالية. أزل جميع عوامل التصفية.",
  "sp.tuition": "التمدرس",
  "sp.transport": "النقل",
  "sp.accompaniment": "المرافقة",
  "sp.editStudent": "تعديل البيانات",
  "sp.takePayment": "تسجيل أداء",
  "sp.takeNextYearPayment": "تسجيل أداء للموسم المقبل",
  "sp.takeHistoricalYearPayment": "تسجيل أداء لموسم سابق",
  "sp.currentYearPaymentNotice": "هذا الأداء مخصص للموسم الدراسي الحالي:",
  "sp.nextYearPaymentNotice": "هذا الأداء مخصص للموسم الدراسي المقبل:",
  "sp.historicalYearPaymentNotice": "هذا الأداء مخصص لموسم دراسي سابق:",
  "sp.currentYearGroup": "الموسم الدراسي الحالي",
  "sp.nextYearGroup": "الموسم الدراسي المقبل",
  "sp.historicalYearGroup": "موسم دراسي سابق",
  "sp.allObligationsPaid": "تم أداء جميع الواجبات.",
  "sp.outstanding": "المبلغ المستحق",
  "sp.overdueCount": "أشهر متأخرة",
  "sp.yearTotal": "مجموع الموسم",
  "sp.acrossPeriods": "يناير · فبراير · مارس",
  "sp.janFeb": "يناير وفبراير 2026",
  "sp.paidThisYear": "المؤدّى منذ شتنبر",
  "sp.mad": "درهم",
  "sp.feeSchedule": "جدول الواجبات",
  "sp.feeScheduleTab": "الواجبات",
  "sp.perMonth": "شهرياً",
  "sp.perMonthShort": "شهرياً",
  "sp.enrollmentFee": "واجب التسجيل",
  "sp.paid": "مؤدّى",
  "sp.overdue": "متأخر",
  "sp.due": "مستحق",
  "sp.upcoming": "قادم",
  "sp.collapsed": "تفاصيل",
  "sp.adjust": "تعديل",
  "sp.manageServiceAmounts": "تعديل مبالغ الخدمات",
  "sp.manageServiceAmountsHelp":
    "أدخل مبلغاً واحداً لكل خدمة. يطبّق التغيير تلقائياً على جميع الأشهر غير المؤداة فقط.",
  "sp.serviceAmountsPaidNote": "الأشهر المؤداة لا تتغير.",
  "sp.saveServiceAmounts": "حفظ مبالغ الخدمات",
  "sp.serviceAmountsSaved": "تم تحديث مبالغ الخدمات.",
  "sp.serviceNotEnabled": "غير مفعّلة",
  "sp.remainingYear": "المتبقّي للموسم",
  "sp.paymentHistory": "سجل الأداءات",
  "sp.cash": "نقداً",
  "sp.cheque": "شيك",
  "sp.transfer": "تحويل",
  "sp.queued": "في الانتظار",
  "sp.syncing": "جارٍ الإرسال",
  "sp.synced": "مُرسل",
  "sp.settled": "مؤدى",
  "sp.cancelled": "ملغاة",
  "sp.details": "المعطيات",
  "sp.guardian": "الوليّ",
  "sp.phone": "الهاتف",
  "sp.birthDate": "تاريخ الميلاد",
  "sp.enrolledOn": "تاريخ التسجيل",
  "sp.blockedTitle": "تسجيل الأداءات موقوف",
  "sp.blockedBody": "مرّت أكثر من سبعة أيام بدون مزامنة. أكمل المزامنة قبل استلام أي مبلغ.",
  "sp.storageBlockedTitle": "يلزم التخزين الآمن",
  "sp.storageBlockedBody":
    "لم يمنح المتصفح التخزين الدائم بعد. ثبّت التطبيق أو اسمح بتخزين بيانات الموقع، ثم أعد المزامنة.",
  "sp.clockBlockedTitle": "يجب التحقق من ساعة الجهاز",
  "sp.clockBlockedBody":
    "تعذّر التحقق من توقيت هذا الجهاز. فعّل التاريخ والوقت التلقائيين، ثم أعد المزامنة.",
  "sp.syncNow": "مزامنة الآن",
  "sp.step1Body": "اختر الأشهر أو واجب التسجيل المطلوب أداؤه. المبلغ المعروض هو المتبقّي لكل فترة.",
  "sp.step2Body":
    "يمكنك تعديل المبلغ المخصّص لكل فترة إن كان الأداء جزئياً. المجموع يجب أن يبقى مساوياً للمبلغ المستلم.",
  "sp.quickSelect": "اختيار سريع:",
  "sp.allOverdue": "كل المتأخرات",
  "sp.clear": "إلغاء الاختيار",
  "sp.period": "الفترة",
  "sp.remaining": "المتبقّي",
  "sp.allocated": "المخصّص",
  "sp.total": "المجموع",
  "sp.valid": "المبالغ متوافقة",
  "sp.invalid": "المجموع لا يطابق المخصّصات",
  "sp.chequeNumber": "رقم الشيك",
  "sp.bank": "البنك",
  "sp.drawer": "الساحب",
  "sp.sender": "المرسل",
  "sp.transferRef": "مرجع التحويل",
  "sp.transferDate": "تاريخ التحويل",
  "sp.receivedDate": "تاريخ الاستلام",
  "sp.note": "ملاحظة",
  "sp.optional": "اختياري",
  "sp.backdatedTitle": "تاريخ سابق — السبب إلزامي",
  "sp.backdatedPlaceholder": "سبب اختيار تاريخ سابق",
  "sp.confirmTitle": "تأكيد الأداء",
  "sp.confirmSub": "راجع قبل الإصدار",
  "sp.student": "التلميذ",
  "sp.periods": "عدد الفترات",
  "sp.obligationsPaid": "الواجبات المؤداة",
  "sp.method": "الطريقة",
  "sp.immutableWarn":
    "بعد التأكيد لا يمكن تعديل الأداء. الإلغاء وحده ممكن، ويترك أثراً دائماً في السجل.",
  "sp.receiptIssued": "تم إصدار الوصل",
  "sp.receiptIssuedSub": "نقداً — الوصل جاهز للطبع والتسليم.",
  "sp.provIssued": "تم إصدار إشعار مؤقّت",
  "sp.provIssuedSub": "في انتظار تصفية الشيك من طرف المدير.",
  "sp.docReceipt": "وصل أداء",
  "sp.docProvisional": "إشعار مؤقّت",
  "sp.docFixedNote": "تصميم الوثيقة ونصوصها محدّدان في القالب الرسمي.",
  "sp.print": "طبع",
  "sp.download": "تحميل",
  "sp.shareGuardian": "مشاركة مع الوليّ",
  "sp.provTitle": "إشعار مؤقّت لا وصل",
  "sp.provBody": "الشيكات والتحويلات لا تُعطي وصلاً نهائياً إلا بعد التصفية.",
  "sp.provNote":
    "الإشعار يحمل شارة «في انتظار التحصيل» ويظهر في قائمة الشيكات والتحويلات إلى أن يؤكّد المدير التصفية.",
  "sp.queuedTitle": "الأداء في طابور الإرسال",
  "sp.queuedBody": "سُجّلت محلياً وستُرسل تلقائياً عند عودة الاتصال.",
  "sp.queuedNote":
    "الوصل يُطبع فوراً بمرجع نهائي؛ الشارة تتحوّل من «في الانتظار» إلى «مُرسل» دون أي تدخّل.",
  "sp.back": "رجوع",
  "sp.next": "التالي",
  "sp.confirmPay": "تأكيد وإصدار",
  "sp.finish": "إغلاق",
  "sp.runningTotal": "المجموع الجاري",
  "sp.stepA": "اختيار الفترات",
  "sp.stepB": "توزيع المبلغ",
  "sp.stepC": "طريقة الأداء",
  "sp.stepD": "التأكيد",
  "sp.stepE": "الوثيقة",
  "sp.identity": "الهوية",
  "sp.enrollment": "التسجيل والخدمات",
  "sp.nameAr": "الاسم بالعربية",
  "sp.nameFr": "الاسم بالفرنسية",
  "sp.cancel": "إلغاء",
  "sp.computedMonthly": "الواجب الشهري المحتسب",
  "sp.saveStudent": "حفظ التلميذ",
  "sp.dupTitle": "يوجد تلميذ بنفس رقم MASSAR",
  "sp.dupBody": "تحقّق قبل المتابعة: التسجيل المزدوج يفسد جدول الواجبات.",
  "sp.openExisting": "فتح الملف الموجود",
  "sp.saveAnyway": "الحفظ رغم ذلك",
  "sp.saveFailTitle": "تعذّر الحفظ",
  "sp.saveFailBody": "تعذّر حفظ التغييرات. لم يُحفظ أي تغيير؛ حاول مرة أخرى.",
  "sp.invalidStudentSaveBody": "راجع الحقول المطلوبة والقسم والسنة الدراسية. رمز MASSAR اختياري.",
  "sp.studentServiceSaveFailedBody":
    "تعذّر تحديث التسجيل والخدمات والواجبات المرتبطة بهما. لم يُحفظ أي تغيير.",
  "sp.fixAndRetry": "تصحيح وإعادة المحاولة",
  "sp.keepDraft": "الاحتفاظ بالمسودّة",
  "sp.invalidMassar": "استعمل من 6 إلى 20 حرفاً أو رقماً.",
  "sp.invalidBirthDate": "اختر تاريخ ميلاد صحيحاً.",
  "sp.invalidPhone": "أدخل رقماً دولياً أو رقماً مغربياً مثل 0611223344.",
  "sp.adjustFee": "تعديل واجب",
  "sp.discount": "تخفيض",
  "sp.waiver": "إعفاء كامل",
  "sp.correction": "تصحيح",
  "sp.lifecycle": "المسار الدراسي",
  "sp.lifecycleStatus": "الحالة الدراسية",
  "sp.paymentStatus": "حالة الأداء",
  "sp.statusActive": "متمدرس",
  "sp.statusWithdrawn": "منسحب",
  "sp.statusGraduated": "متخرج",
  "sp.withdrawStudent": "سحب التلميذ",
  "sp.graduateStudent": "تخريج التلميذ",
  "sp.returnStudent": "إعادة تسجيل التلميذ",
  "sp.correctLifecycle": "تصحيح آخر إجراء",
  "sp.lifecycleEffectiveDate": "تاريخ سريان الإجراء",
  "sp.lifecycleReason": "سبب الإجراء",
  "sp.lifecycleClass": "المستوى عند العودة",
  "sp.lifecycleResultingStatus": "الحالة الصحيحة",
  "sp.lifecycleConfirmation": "راجعت هوية التلميذ والأثر المالي وأؤكد تسجيل هذا الإجراء الدائم.",
  "sp.lifecycleImmutable":
    "لا يُحذف هذا الإجراء ولا يُعدّل. أي تصحيح لاحق يُسجّل كواقعة مرتبطة ويحفظ السجل الأصلي.",
  "sp.lifecycleFutureCancelled": "المتبقي من الواجبات المستقبلية الذي سيُلغى",
  "sp.lifecycleRetainedDebt": "المبلغ غير المؤدى الذي سيبقى مستحقاً",
  "sp.lifecyclePrepaid": "مبالغ مستقبلية مؤداة تبقى محفوظة للمراجعة",
  "sp.lifecyclePendingBlock":
    "توجد شيكات أو تحويلات معلقة مرتبطة بواجبات مستقبلية. صفّها أو ارفضها قبل المتابعة.",
  "sp.lifecyclePreviewing": "جارٍ حساب الأثر المالي…",
  "sp.lifecycleHistory": "سجل المسار الدراسي",
  "sp.lifecycleNoHistory": "لا توجد إجراءات سابقة.",
  "sp.lifecycleSubmit": "تأكيد الإجراء",
  "sp.lifecycleFailed": "تعذر تسجيل الإجراء. لم يتغير شيء.",
  "sp.lifecycleCorrectionConflict":
    "توجد معاملات مالية لاحقة تمنع هذا التصحيح. راجع ملف التلميذ أولاً.",
  "sp.lifecycleGraduationNotAllowed": "التخريج متاح فقط في المستوى الابتدائي النهائي.",
  "sp.lifecycleReturnHelp":
    "تظل ديون ما قبل الانسحاب مستحقة، وتبقى أشهر الغياب ملغاة، وتستأنف الواجبات من تاريخ العودة.",
  "sp.lifecycleCorrectionHelp": "يُحفظ الإجراء الأصلي ويُضاف هذا التصحيح كسجل جديد مرتبط به.",
  "sp.lifecycleWithdrawalHelp":
    "تبقى الواجبات المستحقة إلى تاريخ الانسحاب، ويُلغى فقط المتبقي غير المؤدى بعدها.",
  "sp.lifecycleGraduationHelp":
    "تبقى الواجبات المستحقة إلى تاريخ التخرج، ويُلغى فقط المتبقي غير المؤدى بعدها.",
  "sp.lifecycleTransport": "النقل عند العودة",
  "sp.lifecycleAccompaniment": "المرافقة عند العودة",
  "sp.lifecycleCorrected": "تصحيح",
  "sp.lifecycleWithdrawal": "انسحاب",
  "sp.lifecycleGraduation": "تخرج",
  "sp.lifecycleReturn": "عودة",
  "sp.originalAmount": "المبلغ الأصلي",
  "sp.newRemaining": "المتبقّي بعد التعديل",
  "sp.adjustAmount": "مبلغ التعديل",
  "sp.effectiveDate": "تاريخ السريان",
  "sp.reason": "السبب",
  "sp.adjustWarn": "كل تعديل يُسجّل باسم المستعمل وتاريخه، ويظهر في ملف التلميذ وفي التقارير.",
  "sp.applyAdjust": "تطبيق التعديل",
  "sp.mSep": "شتنبر",
  "sp.mOct": "أكتوبر",
  "sp.mNov": "نونبر",
  "sp.mDec": "دجنبر",
  "sp.mJan": "يناير",
  "sp.mFeb": "فبراير",
  "sp.mMar": "مارس",
  "sp.mApr": "أبريل",
  "sp.mMay": "ماي",
  "sp.mJun": "يونيو",
  "ops.schoolName": "مؤسسة شمس العلوم",
  "ops.mad": "درهم",
  "ops.chequesTitle": "الشيكات والتحويلات",
  "ops.pendingItems": "أداة في انتظار التحصيل",
  "ops.pending": "في انتظار التحصيل",
  "ops.pendingShort": "في الانتظار",
  "ops.settled": "مؤدى",
  "ops.settledTab": "مؤداة",
  "ops.rejected": "مرفوضة",
  "ops.student": "التلميذ",
  "ops.reference": "المرجع",
  "ops.method": "الطريقة",
  "ops.amount": "المبلغ",
  "ops.date": "التاريخ",
  "ops.status": "الحالة",
  "ops.actions": "إجراءات",
  "ops.cheque": "شيك",
  "ops.transfer": "تحويل",
  "ops.cash": "نقداً",
  "ops.awaitingSettlement": "في انتظار التحصيل",
  "ops.confirm": "تأكيد",
  "ops.confirmSettlement": "تأكيد التصفية",
  "ops.reject": "رفض",
  "ops.selectedNone": "لم يُحدّد أي عنصر",
  "ops.queueTotal": "مجموع الطابور:",
  "ops.settleTitle": "تأكيد تصفية الشيك",
  "ops.settleChequeTitle": "تأكيد الشيك",
  "ops.settleTransferTitle": "تأكيد التحويل",
  "ops.settleChequeDate": "تاريخ تحصيل الشيك",
  "ops.settleTransferDate": "تاريخ تأكيد التحويل",
  "ops.rejectChequeDate": "تاريخ رفض الشيك",
  "ops.rejectTransferDate": "تاريخ رفض التحويل",
  "ops.settleChequeReference": "مرجع تحصيل الشيك",
  "ops.settleTransferReference": "المرجع البنكي للتحويل",
  "ops.rejectChequeReason": "سبب رفض الشيك",
  "ops.rejectTransferReason": "سبب رفض التحويل",
  "ops.statementDate": "تاريخ كشف الحساب",
  "ops.statementRef": "مرجع الكشف",
  "ops.optional": "اختياري",
  "ops.cancel": "إلغاء",
  "ops.settleNote":
    "بعد التأكيد يتحوّل الإشعار المؤقّت إلى وصل نهائي، ويُحدَّث جدول واجبات التلميذ.",
  "ops.settleChequeNote":
    "بعد التأكيد يُسجّل الشيك كمحصّل، ويتحوّل الإشعار المؤقّت إلى وصل نهائي، ويُحدَّث جدول واجبات التلميذ.",
  "ops.settleTransferNote":
    "بعد التأكيد يُسجّل التحويل كمستلم، ويتحوّل الإشعار المؤقّت إلى وصل نهائي، ويُحدَّث جدول واجبات التلميذ.",
  "ops.rejectTitle": "رفض الأداة",
  "ops.rejectChequeTitle": "رفض الشيك",
  "ops.rejectTransferTitle": "رفض التحويل",
  "ops.rejectSub": "شيك بدون رصيد أو تحويل لم يُستلم",
  "ops.rejectReason": "سبب الرفض",
  "ops.confirmReject": "تأكيد الرفض",
  "ops.queueEmpty": "لا شيء في الانتظار",
  "ops.queueEmptyBody": "كل الشيكات والتحويلات مؤداة.",
  "ops.settledEmpty": "لا شيء مؤدى",
  "ops.settledEmptyBody": "لم يتم تحصيل أي شيك أو تحويل بعد.",
  "ops.settleFailed": "تعذّر تسجيل التصفية",
  "ops.settleChequeFailed": "تعذّر تسجيل تحصيل الشيك",
  "ops.settleTransferFailed": "تعذّر تسجيل تأكيد التحويل",
  "ops.rejectChequeFailed": "تعذّر تسجيل رفض الشيك",
  "ops.rejectTransferFailed": "تعذّر تسجيل رفض التحويل",
  "ops.settleFailedBody": "لم يستجب الخادم. لم يتغيّر شيء.",
  "ops.retry": "إعادة المحاولة",
  "ops.docReceipt": "وصل أداء",
  "ops.docFixedNote": "تصميم الوثيقة ونصوصها محدّدان في القالب الرسمي.",
  "ops.receiptLanguage": "لغة الوصل",
  "ops.print": "طبع",
  "ops.download": "تحميل",
  "ops.guardianLink": "رابط الوليّ",
  "ops.copy": "نسخ",
  "ops.whatsapp": "واتساب",
  "ops.regenerate": "توليد رابط جديد",
  "ops.revoke": "سحب الرابط",
  "ops.linkNote":
    "الرابط يعرض الوصل فقط ويظلّ صالحاً إلى أن يُسحب أو يُعاد توليده. التوليد الجديد يُبطل السابق فوراً.",
  "ops.cancelPayment": "إلغاء الأداء",
  "ops.cancelTitle": "إلغاء أداء نهائي",
  "ops.cancelWarn":
    "الإلغاء لا يُلغى. الأداء يبقى في السجل بشارة «ملغاة» ويعاد فتح الفترات المعنية.",
  "ops.cancelDate": "تاريخ الإلغاء",
  "ops.cancelReason": "سبب الإلغاء",
  "ops.confirmCancellationCheck": "أفهم أن إلغاء الأداء نهائي ولا يمكن التراجع عنه.",
  "ops.keepPayment": "الاحتفاظ بالأداء",
  "ops.confirmCancel": "إلغاء الأداء نهائياً",
  "ops.cancelled": "ملغاة",
  "ops.cancelledOn": "تاريخ الإلغاء",
  "ops.cancelledBy": "بواسطة",
  "ops.cancelledReasonSample": "خطأ في تسجيل التلميذ — أُعيد المبلغ نقداً بتاريخ 07/02/2026.",
  "ops.viewDocument": "عرض الوثيقة",
  "ops.shareDisabled": "المشاركة معطّلة",
  "ops.reports": "التقارير",
  "ops.daily": "يومي",
  "ops.monthly": "شهري",
  "ops.generate": "توليد التقرير",
  "ops.dailyReport": "التقرير اليومي",
  "ops.generating": "جارٍ توليد التقرير…",
  "ops.receiptsIssued": "وصولات مُصدرة",
  "ops.cashTaken": "المستلم نقداً",
  "ops.cancelledToday": "ملغاة اليوم",
  "ops.noMovements": "لا حركات في هذه الفترة",
  "ops.noMovementsBody": "اختر تاريخاً آخر أو انتقل إلى التقرير الشهري.",
  "ops.reportFailed": "تعذّر توليد التقرير",
  "ops.reportFailedBody": "انتهت مدة الاتصال بالخادم. حاول مرّة أخرى.",
  "ops.authenticationFailedBody": "انتهت الجلسة عبر الإنترنت. سجّل الدخول مجدداً ثم أعد المحاولة.",
  "ops.authorizationFailedBody":
    "هذا الجهاز غير مخوّل لإتمام هذا الطلب. تحقّق من ترخيص الجهاز ثم أعد المحاولة.",
  "ops.networkFailedBody": "تعذّر الوصول إلى الخادم. تحقّق من الاتصال ثم أعد المحاولة.",
  "ops.serverFailedBody": "واجه الخادم خطأً أثناء معالجة الطلب. أعد المحاولة بعد قليل.",
  "ops.responseFailedBody": "تعذّرت قراءة استجابة الخادم. أعد المحاولة.",
  "ops.settings": "الإعدادات",
  "ops.account": "الحساب",
  "ops.roleAdmin": "مدير النظام",
  "ops.accessCodes": "رموز الولوج",
  "ops.deviceRequests": "طلبات الأجهزة",
  "ops.deviceRequestsEmpty": "لا توجد أجهزة مسجلة.",
  "ops.deviceRequestDevice": "الجهاز",
  "ops.deviceRequestAt": "تاريخ الطلب",
  "ops.deviceDecision": "القرار",
  "ops.deviceRequestApprove": "قبول",
  "ops.deviceRequestReject": "رفض",
  "ops.deviceRequestRevoke": "إلغاء الترخيص",
  "ops.deviceRevokeConfirm": "هل تريد إلغاء ترخيص هذا الجهاز فوراً؟",
  "ops.deviceStatusPending": "قيد المراجعة",
  "ops.deviceStatusAuthorized": "مرخّص",
  "ops.deviceStatusRejected": "مرفوض",
  "ops.deviceStatusRevoked": "ملغى",
  "ops.forUser": "المستعمل",
  "ops.purpose": "الغرض",
  "ops.purposePasskey": "تسجيل مفتاح مرور",
  "ops.expiresIn": "ينتهي بعد",
  "ops.codeOnceNote": "يُعرض الرمز مرّة واحدة. إن ضاع، ولّد رمزاً جديداً — القديم يُبطل تلقائياً.",
  "ops.systemStatus": "حالة النظام",
  "ops.service": "الخدمة",
  "ops.worker": "المهام الخلفية",
  "ops.workerLate": "آخر تنفيذ منذ 41 دقيقة",
  "ops.lastSync": "آخر مزامنة",
  "ops.bannerOffline": "أنت تعمل بدون اتصال — التسجيل ما زال مسموحاً",
  "ops.bannerSyncFailed": "فشلت المزامنة",
  "ops.bannerSyncFailedBody": "لم تُرسل الأداءات المحفوظة. لم تُفقد أي معلومة.",
  "ops.bannerUpdate": "تحديث جاهز",
  "ops.bannerUpdateBody": "إعادة التشغيل تستغرق ثوانٍ ولا تُفقد أي بيانات.",
  "ops.restartNow": "إعادة التشغيل",
  "ops.bannerUpdateAfterSync": "التحديث سيبدأ بعد المزامنة",
  "ops.bannerUpdateAfterSyncBody": "توجد أداءات في الانتظار؛ لن يُعاد التشغيل قبل إرسالها.",
  "ops.genericEmpty": "لا يوجد شيء هنا بعد",
  "ops.genericEmptyBody": "عندما تُسجّل أول عملية ستظهر في هذه القائمة.",
  "ops.genericError": "حدث خطأ",
  "ops.genericErrorBody": "لم نتمكّن من تحميل هذا الجزء. باقي الصفحة يعمل بشكل عادي.",
  "ops.ladder1": "الحالة سليمة. نقطة خضراء صغيرة في الشريط، لا شيء آخر.",
  "ops.ladder2": "نقطة كهرمانية وتنبيه هادئ داخل لوحة المزامنة فقط.",
  "ops.ladder3": "التسجيل موقوف: شريط أحمر، زر التسجيل معطّل، ودعوة صريحة للمزامنة.",
  "ops.ladderOfflineTitle": "بدون اتصال",
  "ops.ladder4": "الأرقام المحسوبة على الخادم غير متوفّرة، والتسجيل يعمل ويُخزَّن محلياً.",
} as const;

export type MessageKey = keyof typeof ar;

export const fr = {
  "app.brand": "Chams.Pay",
  "app.placeholderBrand": "Gestion des paiements scolaires",
  "app.phase": "Gestion scolaire",
  "pwa.installTitle": "Installez Chams.Pay sur votre téléphone",
  "pwa.installBody":
    "Utilisez Chams.Pay comme une application autonome, avec un accès plus rapide et une meilleure expérience hors ligne.",
  "pwa.installIosBody":
    "Touchez Partager, puis « Sur l’écran d’accueil » pour installer l’application.",
  "pwa.installManualBody":
    "Ouvrez le menu du navigateur, puis choisissez « Installer l’application » ou « Ajouter à l’écran d’accueil ».",
  "pwa.installAction": "Installer l’application",
  "pwa.installUnderstood": "Compris",
  "pwa.installLater": "Plus tard",
  "pwa.pullToRefresh": "Tirez encore pour actualiser",
  "pwa.refreshing": "Actualisation du contenu",
  "mobile.backToExit": "Appuyez encore sur Retour pour quitter",
  "mobile.chooseStudent": "Choisissez un élève pour enregistrer le paiement",
  "mobile.downloadStarted": "Le téléchargement a commencé",
  "mobile.contentRefreshed": "Contenu actualisé",
  "mobile.copied": "Copié",
  "mobile.studentCreated": "Élève créé",
  "mobile.studentUpdated": "Informations de l’élève mises à jour",
  "mobile.serviceAmountsUpdated": "Montants des services mis à jour",
  "mobile.lifecycleUpdated": "Statut de l’élève mis à jour",
  "mobile.paymentRecorded": "Paiement enregistré",
  "mobile.instrumentSettled": "Encaissement confirmé",
  "mobile.instrumentRejected": "Instrument rejeté",
  "mobile.paymentCancelled": "Paiement annulé",
  "mobile.settingsSaved": "Paramètres enregistrés",
  "mobile.rolloverCompleted": "Passage à l’année suivante terminé",
  "mobile.installationApproved": "Appareil approuvé",
  "mobile.installationRejected": "Appareil rejeté",
  "mobile.installationRevoked": "Autorisation de l’appareil révoquée",
  "mobile.accessCodeIssued": "Code d’accès émis",
  "mobile.syncCompleted": "Synchronisation terminée",
  "auth.eyebrow": "Chams.Pay",
  "auth.title": "Connexion",
  "auth.description": "Accédez à Chams.Pay avec votre clé d’accès.",
  "auth.identifier": "Identifiant utilisateur",
  "auth.identifierHint": "Saisissez l’identifiant de votre compte.",
  "auth.signIn": "Se connecter",
  "auth.enroll": "Enregistrer une clé d’accès",
  "auth.enrollmentCode": "Code d’inscription ou de récupération",
  "auth.useCode": "Continuer l’inscription",
  "auth.codeHint": "Émis par l’administrateur système, valable une fois pendant 30 minutes.",
  "auth.error": "La vérification a échoué. Contrôlez les données et réessayez.",
  "auth.enrolled": "Clé d’accès enregistrée. Vous pouvez maintenant vous connecter.",
  "auth.synthetic": "Accès sécurisé",
  "installation.eyebrow": "Cet appareil",
  "installation.title": "Associer l’appareil",
  "installation.description":
    "Enregistrez cet appareil, puis demandez son autorisation à l’administrateur système.",
  "installation.register": "Enregistrer l’appareil",
  "installation.authorize": "Autoriser l’appareil",
  "installation.pending": "Appareil enregistré, en attente d’autorisation.",
  "installation.pendingHelp":
    "L’administrateur système doit autoriser cet appareil avant l’accès du gestionnaire financier.",
  "installation.adminSignIn": "Se connecter comme administrateur système",
  "installation.authorized": "Installation autorisée",
  "installation.deviceCode": "Code appareil",
  "offline.setupTitle": "Configurer l’accès hors ligne",
  "offline.setupDescription":
    "Choisissez un code à 8 chiffres pour ouvrir l’application sans connexion.",
  "offline.pin": "Code à 8 chiffres",
  "offline.prepare": "Configurer l’application",
  "offline.lockedTitle": "Application verrouillée",
  "offline.lockedDescription": "Saisissez votre code pour ouvrir l’application.",
  "offline.unlock": "Ouvrir l’application",
  "offline.invalidPin":
    "PIN incorrect. Un délai de sécurité s’applique sans supprimer les données.",
  "offline.blocked":
    "Une réautorisation en ligne est requise après 10 essais. Aucune donnée n’a été effacée.",
  "offline.corrupt":
    "La copie chiffrée ne peut pas être vérifiée. La lecture est bloquée et les données sont conservées.",
  "offline.freshness": "Dernière synchronisation",
  "offline.freshnessShort": "Dernière synchronisation",
  "offline.statusOnline": "En ligne",
  "offline.statusOffline": "Hors ligne",
  "offline.localMode": "Mode hors ligne",
  "offline.onlineMode": "En ligne",
  "offline.sync": "Synchroniser",
  "offline.onlineOnly": "Une connexion est requise pour synchroniser.",
  "sync.unsynchronized": "Opérations en attente",
  "sync.ready": "Prêt",
  "sync.warning24": "Plus de 24 heures depuis la dernière synchronisation",
  "sync.warning72": "Alerte : plus de 72 heures depuis la dernière synchronisation",
  "sync.blocked": "Synchronisez avant d’enregistrer un nouveau paiement",
  "sync.queued": "En attente",
  "sync.syncing": "Envoi en cours",
  "sync.synced": "Synchronisé",
  "sync.failed": "La synchronisation a échoué. Une nouvelle tentative sera effectuée.",
  "sync.rejected": "Une opération doit être vérifiée par l’administrateur système.",
  "nav.students": "Élèves",
  "nav.access": "Utilisateurs et appareils",
  "nav.settings": "Paramètres",
  "nav.lock": "Verrouiller",
  "nav.signOut": "Se déconnecter",
  "students.search": "Rechercher un élève",
  "students.searchPlaceholder": "Nom, STU-0001 ou MASSAR",
  "students.results": "Résultats de recherche",
  "students.noResults": "Aucun résultat correspondant",
  "students.class": "Niveau",
  "students.services": "Services actuels",
  "students.serviceTuition": "Scolarité",
  "students.serviceTransport": "Transport",
  "students.serviceAccompaniment": "Accompagnement",
  "students.profile": "Dossier élève",
  "students.back": "Retour aux résultats",
  "students.birthDate": "Date de naissance",
  "students.guardian": "Responsable principal",
  "students.enrollment": "Inscription actuelle",
  "students.academicYear": "Année scolaire",
  "students.enrolledAt": "Date d’inscription",
  "students.obligations": "Frais",
  "students.total": "Total annuel",
  "students.outstanding": "Reste dû",
  "students.overdue": "Échéances en retard",
  "students.register": "Inscrire un élève",
  "students.edit": "Modifier l’élève",
  "students.save": "Enregistrer",
  "students.nameAr": "Nom en arabe",
  "students.nameFr": "Nom en français",
  "students.massar": "Code MASSAR",
  "students.guardianName": "Responsable principal",
  "students.guardianPhone": "Téléphone du responsable",
  "students.transport": "Transport",
  "students.accompaniment": "Accompagnement",
  "students.formDescription": "Saisissez l’identité et l’inscription de l’élève.",
  "students.duplicate": "Un élève utilise déjà ces informations. Vérifiez le code MASSAR.",
  "students.saveFailed": "L’élève n’a pas été enregistré. Vérifiez les champs et réessayez.",
  "students.saved": "Élève enregistré.",
  "students.selectForPayment": "Recherchez l’élève pour commencer le paiement.",
  "students.showAllObligations": "Afficher tous les frais",
  "students.noPayments": "Aucun paiement enregistré.",
  "students.mutationDeferred": "La modification d’élève n’est pas disponible en phase 01",
  "admin.title": "Émettre un code à usage unique",
  "admin.description": "Le code s’utilise une seule fois pendant 30 minutes.",
  "admin.user": "Utilisateur",
  "admin.purpose": "Objet",
  "admin.enrollment": "Inscription",
  "admin.recovery": "Récupération",
  "admin.issue": "Émettre le code",
  "admin.issued": "Copiez le code maintenant ; il ne sera plus affiché.",
  "profile.title": "Compte",
  "profile.role": "Rôle",
  "profile.systemAdministrator": "Administrateur système",
  "profile.financialAdministrator": "Gestionnaire financier",
  "profile.syncTitle": "Synchronisation",
  "profile.lastSync": "Dernière synchronisation",
  "profile.pendingCount": "Opérations en attente",
  "profile.synchronized": "Synchronisé",
  "profile.offline": "Hors ligne",
  "profile.syncing": "Synchronisation en cours",
  "profile.details": "Détails",
  "settings.title": "Paramètres",
  "settings.account": "Compte",
  "settings.accountDescription": "Informations du compte et rôle actuel.",
  "settings.usersDevices": "Utilisateurs et appareils",
  "settings.systemStatus": "État du système",
  "settings.systemStatusDescription": "État des services nécessaires au travail.",
  "settings.service": "Service de l’application",
  "settings.background": "Tâches en arrière-plan",
  "settings.available": "Disponible",
  "settings.unavailable": "Indisponible",
  "settings.backToStudents": "Retour aux élèves",
  "settings.schoolSettings": "Paramètres de l’établissement",
  "settings.schoolIdentity": "Identité de l’établissement",
  "settings.schoolNameAr": "Nom de l’établissement en arabe",
  "settings.schoolNameFr": "Nom de l’établissement en français",
  "settings.schoolEmail": "Adresse e-mail",
  "settings.schoolPhone": "Téléphone de l’établissement",
  "settings.addressAr": "Adresse en arabe",
  "settings.addressFr": "Adresse en français",
  "settings.financialSettings": "Tarifs de l’année scolaire actuelle",
  "settings.preschoolRegistration": "Inscription — préscolaire",
  "settings.primaryRegistration": "Inscription — primaire",
  "settings.preschoolTuition": "Scolarité mensuelle — préscolaire",
  "settings.primaryTuition": "Scolarité mensuelle — primaire",
  "settings.transportFee": "Transport mensuel",
  "settings.accompanimentFee": "Accompagnement mensuel",
  "settings.prospectiveFees":
    "Ces tarifs s’appliquent aux nouveaux frais de l’année actuelle. Les frais et paiements antérieurs restent inchangés.",
  "settings.classes": "Niveaux et passage",
  "settings.classLabel": "Niveau",
  "settings.cycle": "Cycle",
  "settings.preschool": "Préscolaire",
  "settings.primary": "Primaire",
  "settings.nextClass": "Niveau de l’année suivante",
  "settings.addClass": "Ajouter un niveau",
  "settings.removeClass": "Supprimer le niveau",
  "settings.saveGlobal": "Enregistrer les paramètres généraux",
  "settings.saveFees": "Enregistrer les tarifs",
  "settings.saved": "Paramètres généraux enregistrés.",
  "settings.loadFailed": "Impossible de charger les paramètres de l’établissement.",
  "settings.academicYear": "Année scolaire",
  "settings.currentSchoolYear": "Année scolaire actuelle",
  "settings.nextSchoolYear": "Année scolaire suivante",
  "settings.advanceYear": "Ouvrir les paiements anticipés de l’année suivante",
  "settings.advanceYearHelp":
    "Vérifiez les tarifs de l’année suivante avant de créer ses frais. Les valeurs sont initialement copiées depuis l’année actuelle.",
  "settings.advanceYearActiveHelp":
    "Les tarifs de l’année suivante sont figés et ses paiements peuvent être encaissés sans modifier l’inscription actuelle.",
  "settings.advanceYearWarning":
    "Cette action crée les frais de l’année suivante pour tous les élèves actifs admissibles, hors niveaux terminaux. Les tarifs ne pourront plus être modifiés après confirmation.",
  "settings.advanceYearConfirm":
    "J’ai vérifié les tarifs et je confirme l’ouverture des paiements anticipés.",
  "settings.advanceYearAction": "Ouvrir les paiements anticipés",
  "settings.advanceYearActive": "Les paiements anticipés de l’année suivante sont ouverts.",
  "settings.studentsEligible": "élèves admissibles",
  "settings.advanceYearDialogTitle": "Confirmer l’ouverture des paiements anticipés",
  "settings.advanceYearDialogBody":
    "Vérifiez l’année, les tarifs et le nombre d’élèves. Cette action figera les tarifs et créera les frais dans une seule opération.",
  "settings.advanceYearDialogConfirm": "Confirmer et ouvrir",
  "settings.advanceYearActivating": "Ouverture en cours…",
  "settings.advanceYearActionFailed":
    "L’ouverture n’a pas pu être confirmée. L’état actuel a été vérifié et vous pouvez réessayer sans risque.",
  "settings.rollover": "Passage à l’année suivante",
  "settings.rolloverHelp":
    "Passe tous les élèves et leurs services dans l’année suivante, puis crée ses frais selon les tarifs actuels. L’année scolaire va de septembre à juillet.",
  "settings.rolloverWarning":
    "Cette opération globale ne peut pas être annulée. Les paiements et frais antérieurs restent intacts.",
  "settings.rolloverConfirm":
    "J’ai vérifié les tarifs et je confirme le passage global à l’année suivante.",
  "settings.rolloverAction": "Passer tout le monde à l’année suivante",
  "settings.rolloverDialogTitle": "Confirmer le passage global",
  "settings.rolloverDialogBody":
    "Tous les élèves et services seront passés et les frais de l’année suivante seront créés. Cette opération est irréversible.",
  "settings.rolloverDialogCancel": "Revenir",
  "settings.rolloverDialogConfirm": "Confirmer le passage",
  "settings.rolloverComplete": "Passage à l’année suivante terminé.",
  "settings.studentsAdvanced": "élèves passés",
  "settings.obligationsCreated": "nouveaux frais",
  "update.ready": "Mettre à jour l’application",
  "update.blocked": "La mise à jour démarrera après la synchronisation en cours.",
  "language.arabic": "العربية",
  "language.french": "Français",
  "login.eyebrow": "Portail de gestion financière",
  "login.title": "Une base claire pour chaque opération, avant même la finance.",
  "login.description":
    "Ceci est un aperçu synthétique de l’application connectée. L’authentification sécurisée et les vrais comptes sont reportés à la phase 01.",
  "login.previewNotice":
    "Accès synthétique local uniquement · aucune authentification de production",
  "login.previewAction": "Ouvrir l’aperçu synthétique",
  "login.productionUnavailable": "L’authentification de production n’est pas active en phase 00",
  "login.foundationLabel": "Interface bilingue reliée à la base de données",
  "nav.status": "État du système",
  "nav.foundation": "Guide d’interface",
  "shell.preview": "Aperçu local synthétique",
  "shell.role": "Gestionnaire financier synthétique",
  "shell.title": "Élèves",
  "shell.subtitle": "Socle visible et connecté de la phase 00",
  "connectivity.online": "En ligne",
  "connectivity.offline": "Hors ligne",
  "status.eyebrow": "Contrôle direct",
  "status.title": "État de l’architecture applicative",
  "status.description":
    "Ces données viennent de Fastify après une requête PostgreSQL et la vérification du rythme du worker.",
  "status.loading": "Vérification de la base et du worker…",
  "status.ready": "Tous les composants de l’aperçu sont prêts",
  "status.degraded": "Le service répond, mais le worker n’est pas prêt",
  "status.error": "Impossible de joindre l’état du système",
  "status.unavailable": "Service temporairement indisponible",
  "status.retry": "Réessayer",
  "status.database": "PostgreSQL",
  "status.migrations": "Migrations",
  "status.worker": "Worker",
  "status.dataset": "Données synthétiques",
  "status.connected": "Connectée",
  "status.active": "Actif",
  "status.seeded": "Initialisées",
  "status.checked": "Dernier contrôle",
  "foundation.eyebrow": "Langage d’interface",
  "foundation.title": "Un système, deux directions équivalentes",
  "foundation.description":
    "L’arabe est conçu d’abord en RTL et le français reste équivalent en LTR, avec des chiffres occidentaux et une isolation nette des références mixtes.",
  "foundation.reference": "Référence d’essai",
  "foundation.date": "Date affichée",
  "foundation.amount": "Montant d’essai",
  "foundation.states": "États fondamentaux de l’interface",
  "state.empty": "Aucune notification pour le moment",
  "state.emptyHelp": "Les états opérationnels apparaîtront ici dans les phases suivantes.",
  "state.loading": "Chargement en cours",
  "state.error": "Une erreur récupérable est survenue",
  "state.unavailable": "Action indisponible hors ligne",
  "state.recovery": "Une vérification est nécessaire",
  "state.recoveryHelp": "Les preuves restent conservées lorsqu’une récupération est nécessaire.",
  "common.ready": "Prêt",
  "common.notReady": "Non prêt",
  "common.close": "Fermer",
  "entry.schoolName": "Établissement Chams Al-Ouloum",
  "entry.studentsWord": "élèves",
  "entry.heroTitle": "La gestion des frais de scolarité, au calme.",
  "entry.heroBody": "Encaisser, suivre les arriérés, délivrer les reçus — même sans connexion.",
  "entry.heroStatus": "Service opérationnel",
  "entry.tabLogin": "Clé d'accès",
  "entry.tabRegister": "Enregistrer une clé",
  "entry.signinTitleIdle": "Bon retour",
  "entry.signinSubIdle": "Utilisez la clé d'accès enregistrée sur cet appareil.",
  "entry.signinTitleSubmit": "Vérification…",
  "entry.signinSubSubmit": "Terminez la vérification sur votre appareil.",
  "entry.signinTitleErr": "Connexion impossible",
  "entry.signinSubErr": "Clé d'accès non reconnue.",
  "entry.enrollTitleIdle": "Enregistrer une nouvelle clé d’accès",
  "entry.enrollSubIdle": "Saisissez le code temporaire, puis créez la clé sur votre appareil.",
  "entry.enrollTitleSubmit": "Enregistrement de la clé…",
  "entry.enrollSubSubmit": "Terminez la création de la clé d’accès sur votre appareil.",
  "entry.enrollTitleErr": "Enregistrement impossible",
  "entry.enrollSubErr": "La clé n’a pas été créée. Le code temporaire n’a pas été utilisé.",
  "entry.username": "Identifiant",
  "entry.passkeyTitle": "Vérification par clé d'accès",
  "entry.passkeyBody": "Empreinte ou code de l'appareil. Aucun mot de passe stocké.",
  "entry.signinErrTitle": "Clé d'accès inconnue sur cet appareil",
  "entry.signinErrBody":
    "Enregistrez une nouvelle clé avec un code temporaire, ou demandez une réautorisation.",
  "entry.enrollErrTitle": "La clé d’accès n’a pas été enregistrée",
  "entry.enrollErrBody":
    "Vérifiez que le code temporaire est encore valable, puis réessayez. Il n’est utilisé qu’après un enregistrement réussi.",
  "entry.enrollErrCompatibleBody":
    "Le code temporaire n’a pas été utilisé. Réessayez avec un enregistrement compatible avec cet appareil ; l’accès hors ligne restera disponible avec le code PIN.",
  "entry.btnIdle": "Se connecter avec la clé",
  "entry.btnSubmit": "Vérification…",
  "entry.btnErr": "Réessayer",
  "entry.useOffline": "Accès hors ligne (code PIN)",
  "entry.oneTimeCode": "Code à usage unique",
  "entry.codeHint": "Code fourni par l'administrateur, à usage unique et valable 30 minutes.",
  "entry.registerPasskey": "Enregistrer la clé d'accès",
  "entry.enrollBtnSubmit": "Enregistrement de la clé…",
  "entry.enrollRetry": "Réessayer l’enregistrement",
  "entry.enrollRetryCompatible": "Réessayer en mode compatible",
  "entry.existingPasskeyTitle": "Cette clé d’accès existe déjà sur cet appareil",
  "entry.existingPasskeyBody":
    "Windows Hello partage ses clés entre les profils du navigateur. La connexion a été sélectionnée avec le bon identifiant ; le code temporaire n’a pas été utilisé.",
  "entry.onlineSessionRequiredTitle": "Session en ligne à renouveler",
  "entry.onlineSessionRequiredBody":
    "La session du serveur a expiré. Reconnectez-vous pour charger le tableau de bord, les tableaux et les rapports.",
  "entry.serverUnreachableTitle": "Serveur temporairement inaccessible",
  "entry.serverUnreachableBody":
    "La copie locale est ouverte en sécurité, mais le serveur reste inaccessible. Réessayez ou reconnectez-vous en ligne.",
  "entry.sessionRestoringTitle": "Restauration de la session serveur",
  "entry.sessionRestoringBody":
    "La copie locale reste disponible pendant la vérification de la session en ligne.",
  "entry.regDoneTitle": "Clé d'accès enregistrée",
  "entry.regDoneBody": "Vous pouvez désormais vous connecter depuis cet appareil.",
  "entry.dev1Title": "Ce navigateur n'est pas enregistré",
  "entry.dev1Body":
    "Chaque navigateur doit être enregistré puis approuvé par l'administrateur avant utilisation.",
  "entry.deviceFingerprint": "Empreinte de l'appareil",
  "entry.registerDevice": "Enregistrer cet appareil",
  "entry.dev2Title": "En attente d'approbation",
  "entry.dev2Body":
    "Demande envoyée. La session s'ouvrira automatiquement dès l'approbation — inutile de recharger.",
  "entry.requestSent": "Demande envoyée",
  "entry.checkAgain": "Vérifier maintenant",
  "entry.dev3Title": "Demande d'autorisation d'appareil",
  "entry.dev3Body":
    "Vérifiez l'empreinte et le demandeur avant d'approuver. L'autorisation est révocable à tout moment.",
  "entry.requester": "Demandeur",
  "entry.approve": "Approuver",
  "entry.reject": "Refuser",
  "entry.dev4Title": "Enregistrement impossible",
  "entry.dev4Body":
    "L'enregistrement de cet appareil n'a pas abouti. Réessayez, ou contactez l'administrateur si cela persiste.",
  "entry.dev4Detail": "Échec de l’enregistrement",
  "entry.retry": "Réessayer",
  "entry.contactAdmin": "Contacter l'administrateur",
  "entry.pinSetupTitle": "Configuration hors ligne",
  "entry.pinSetupSub": "code à 8 chiffres",
  "entry.pinSetupBody":
    "Ce code déverrouille la copie locale chiffrée sans connexion. Il est irrécupérable — en cas d'oubli, la configuration se refait en ligne.",
  "entry.pinNew": "Nouveau code",
  "entry.pinConfirm": "Confirmation",
  "entry.pinShow": "Afficher le code",
  "entry.pinHide": "Masquer le code",
  "entry.pinRule1": "Huit chiffres",
  "entry.pinRule2": "Pas de suite ni de répétition",
  "entry.pinSave": "Enregistrer et préparer la copie locale",
  "entry.pinMismatch": "Les codes ne correspondent pas",
  "entry.pinMismatchBody": "Ressaisissez la confirmation.",
  "entry.pinPreparing": "Préparation de la copie locale",
  "entry.lockedTitle": "Application verrouillée",
  "entry.lockSubIdle": "Saisissez votre code PIN pour accéder à l’application.",
  "entry.lockSubWrong": "Code incorrect. Réessayez.",
  "entry.wrongPin": "Code incorrect",
  "entry.usePasskey": "Déverrouiller par empreinte ou clé d’accès",
  "entry.attemptsLeft": "3 tentatives restantes",
  "entry.signInOnline": "Se connecter en ligne à la place",
  "entry.useAnotherAccount": "Utiliser un autre compte",
  "entry.lockoutTitle": "Accès hors ligne suspendu",
  "entry.lockoutBody":
    "Après dix échecs, l'ouverture exige une connexion en ligne et une nouvelle approbation de l'appareil. Aucune donnée n'est effacée.",
  "entry.failedAttempts": "Tentatives échouées",
  "entry.corruptTitle": "Copie locale corrompue",
  "entry.corruptBody":
    "L'intégrité des données locales n'a pas pu être vérifiée. Aucun paiement perdu : la file d'envoi est stockée séparément.",
  "entry.rebuildCopy": "Reconstruire la copie locale",
  "dash.schoolName": "Établissement Chams Al-Ouloum",
  "dash.workspace": "Espace de travail",
  "dash.nav1": "Tableau de bord",
  "dash.nav2": "Élèves",
  "dash.nav3": "Chèques & virements",
  "dash.tab3": "Chèques",
  "dash.nav4": "Rapports",
  "dash.nav5": "Paramètres",
  "dash.adminOnly": "ADMIN",
  "dash.dashTitle": "Tableau de bord",
  "dash.dashSub": "Année scolaire 2025 – 2026",
  "dash.obligationMonth": "Mois d'échéance",
  "dash.monthLabel": "Mars 2026",
  "dash.range": "Période",
  "dash.activityPeriod": "Période d'activité",
  "dash.periodWeek": "Cette semaine",
  "dash.periodMonth": "Ce mois",
  "dash.periodAcademicYear": "Année scolaire",
  "dash.periodCustom": "Ou choisir une période",
  "dash.year": "Année",
  "dash.takePayment": "Encaisser",
  "dash.collectionRate": "TAUX DE RECOUVREMENT",
  "dash.expected": "Attendu",
  "dash.selectedPeriod": "PÉRIODE SÉLECTIONNÉE",
  "dash.currentSituation": "SITUATION ACTUELLE",
  "dash.overdueReceivables": "CRÉANCES EN RETARD",
  "dash.activityCollections": "Encaissements",
  "dash.noCollectionsForPeriod": "Aucun encaissement sur cette période",
  "dash.academicCollection": "Recouvrement par mois d'échéance",
  "dash.academicCollectionSub": "attendu contre encaissé",
  "dash.attentionQueue": "À traiter",
  "dash.urgentAttention": "Arriérés de 2 mois et plus",
  "dash.registrationAttention": "Inscriptions non réglées",
  "dash.oldestPending": "Plus ancien en attente",
  "dash.noExpected": "Aucun montant attendu",
  "dash.studentsWord": "élèves",
  "dash.vsLastMonth": "vs mois dernier",
  "dash.netIncome": "RECETTES NETTES",
  "dash.monthToDate": "DEPUIS LE DÉBUT DU MOIS",
  "dash.mad": "MAD",
  "dash.gross": "Brut",
  "dash.cancellations": "Annulations",
  "dash.net": "Net",
  "dash.urgentArrears": "ARRIÉRÉS URGENTS",
  "dash.arrearsAmount": "Montant dû",
  "dash.viewList": "Voir la liste",
  "dash.pendingInstruments": "EN ATTENTE D'ENCAISSEMENT",
  "dash.pendingAmount": "Montant en attente",
  "dash.cheques": "chèques",
  "dash.transfers": "virements",
  "dash.trendTitle": "Évolution du recouvrement",
  "dash.trendSub": "taux mensuel",
  "dash.incomeBreakdown": "Composition des recettes",
  "dash.lateRegistrations": "INSCRIPTIONS TARDIVES",
  "dash.arrearsByMonths": "Arriérés par ancienneté",
  "dash.arrearsSub": "chaque chiffre ouvre la liste filtrée",
  "dash.openStudents": "Ouvrir les élèves",
  "dash.oneMonth": "1 mois",
  "dash.twoMonths": "2 mois",
  "dash.threePlus": "3 mois et plus",
  "dash.captureReadiness": "APTITUDE À ENCAISSER",
  "dash.ok": "OK",
  "dash.readinessNote":
    "Encaissement autorisé. Alerte au-delà de 72 h sans synchronisation ; blocage après sept jours.",
  "dash.userRole": "Administratrice financière",
  "dash.online": "En ligne",
  "dash.offline": "Hors ligne",
  "dash.lastSync": "Dernière sync.",
  "dash.pendingPayments": "Paiements en attente",
  "dash.localCopy": "Copie locale",
  "dash.syncNow": "Synchroniser",
  "dash.readinessWarn":
    "Plus de 72 h sans synchronisation. L'encaissement sera bloqué après sept jours.",
  "dash.lock": "Verrouiller",
  "dash.signOut": "Se déconnecter",
  "dash.retry": "Réessayer",
  "dash.unavailable": "Indisponible",
  "dash.offlineTitle": "Chiffres indisponibles hors ligne",
  "dash.offlineBody":
    "Les indicateurs sont calculés sur le serveur. Vous pouvez continuer à encaisser : les paiements partiront à la reconnexion.",
  "dash.offlineActions": "Ce que vous pouvez faire maintenant",
  "dash.failedTitle": "Certains indicateurs n'ont pas pu être chargés",
  "dash.failedBody":
    "Délai d'attente du serveur dépassé. Les chiffres affichés peuvent être obsolètes.",
  "dash.blocked": "Encaissement bloqué",
  "dash.blockedTitle": "Encaissement bloqué — synchronisation requise",
  "dash.blockedBody":
    "Plus de sept jours sans synchronisation. Aucun nouveau paiement ne peut être enregistré.",
  "dash.storageBlockedTitle": "Encaissement bloqué — stockage sécurisé requis",
  "dash.storageBlockedBody":
    "Le navigateur n’a pas encore accordé le stockage persistant. Installez l’application ou autorisez le stockage du site, puis resynchronisez.",
  "dash.clockBlockedTitle": "Encaissement bloqué — horloge à vérifier",
  "dash.clockBlockedBody":
    "Impossible de vérifier l’heure de cet appareil. Activez la date et l’heure automatiques, puis resynchronisez.",
  "dash.blockedHint": "Terminez la synchronisation pour réactiver l'encaissement.",
  "dash.m1": "Oct",
  "dash.m2": "Nov",
  "dash.m3": "Déc",
  "dash.m4": "Jan",
  "dash.m5": "Fév",
  "dash.m6": "Mar",
  "dash.m7": "Avr",
  "sp.schoolName": "Établissement Chams Al-Ouloum",
  "sp.students": "Élèves",
  "sp.enrolled": "élèves inscrits",
  "sp.summaryCount": "Nombre",
  "sp.summaryStudent": "élève",
  "sp.summaryStudents": "élèves",
  "sp.summarySearch": "Recherche",
  "sp.summaryLevel": "Niveau",
  "sp.summaryStatus": "Statut",
  "sp.summaryPayment": "Paiement",
  "sp.summaryLate": "Retard",
  "sp.summaryArrears": "Arriérés",
  "sp.summaryTwoPlusMonths": "2 mois ou plus",
  "sp.summaryRegistrationUnpaid": "Frais d’inscription impayés",
  "sp.searchValue": "Sami",
  "sp.searchHint": "nom · STU · MASSAR",
  "sp.registerStudent": "Inscrire un élève",
  "sp.clearSearch": "Effacer la recherche",
  "sp.filters": "Filtres",
  "sp.filterAll": "Tous",
  "sp.clearFilters": "Réinitialiser tous les filtres",
  "sp.filterArrears": "Arriérés seulement",
  "sp.filterClass": "+ Niveau",
  "sp.filterService": "+ Services",
  "sp.results": "résultats",
  "sp.class": "Niveau",
  "sp.section": "Section",
  "sp.reference": "Référence",
  "sp.monthsLate": "mois de retard",
  "sp.monthLate": "mois de retard",
  "sp.upToDate": "À jour",
  "sp.newlyEnrolled": "Nouvelle inscription",
  "sp.emptyTitle": "Aucun résultat",
  "sp.emptyBody": "Vérifiez le nom ou le code MASSAR, ou inscrivez un nouvel élève.",
  "sp.filteredEmptyBody":
    "Aucun élève ne correspond aux filtres actuels. Réinitialisez tous les filtres.",
  "sp.tuition": "Scolarité",
  "sp.transport": "Transport",
  "sp.accompaniment": "Accompagnement",
  "sp.editStudent": "Modifier la fiche",
  "sp.takePayment": "Encaisser",
  "sp.takeNextYearPayment": "Encaisser pour l’année suivante",
  "sp.takeHistoricalYearPayment": "Encaisser pour une année précédente",
  "sp.currentYearPaymentNotice": "Ce paiement concerne l’année scolaire actuelle :",
  "sp.nextYearPaymentNotice": "Ce paiement concerne l’année scolaire suivante :",
  "sp.historicalYearPaymentNotice": "Ce paiement concerne une année scolaire précédente :",
  "sp.currentYearGroup": "Année scolaire actuelle",
  "sp.nextYearGroup": "Année scolaire suivante",
  "sp.historicalYearGroup": "Année scolaire précédente",
  "sp.allObligationsPaid": "Toutes les obligations sont payées.",
  "sp.outstanding": "RESTE À PAYER",
  "sp.overdueCount": "MOIS EN RETARD",
  "sp.yearTotal": "TOTAL DE L'ANNÉE",
  "sp.acrossPeriods": "Janvier · Février · Mars",
  "sp.janFeb": "Janvier et février 2026",
  "sp.paidThisYear": "Payé depuis septembre",
  "sp.mad": "MAD",
  "sp.feeSchedule": "Échéancier",
  "sp.feeScheduleTab": "Échéancier",
  "sp.perMonth": "par mois",
  "sp.perMonthShort": "/ mois",
  "sp.enrollmentFee": "Frais d'inscription",
  "sp.paid": "Payé",
  "sp.overdue": "En retard",
  "sp.due": "À payer",
  "sp.upcoming": "À venir",
  "sp.collapsed": "Détails",
  "sp.adjust": "Ajuster",
  "sp.manageServiceAmounts": "Modifier les montants des services",
  "sp.manageServiceAmountsHelp":
    "Saisissez un montant unique par service. Il sera appliqué automatiquement à tous les mois non payés.",
  "sp.serviceAmountsPaidNote": "Les mois déjà payés restent inchangés.",
  "sp.saveServiceAmounts": "Enregistrer les montants",
  "sp.serviceAmountsSaved": "Montants des services mis à jour.",
  "sp.serviceNotEnabled": "Non activé",
  "sp.remainingYear": "RESTE SUR L'ANNÉE",
  "sp.paymentHistory": "Historique",
  "sp.cash": "Espèces",
  "sp.cheque": "Chèque",
  "sp.transfer": "Virement",
  "sp.queued": "En file",
  "sp.syncing": "Envoi…",
  "sp.synced": "Envoyé",
  "sp.settled": "Encaissé",
  "sp.cancelled": "Annulé",
  "sp.details": "Informations",
  "sp.guardian": "Tuteur",
  "sp.phone": "Téléphone",
  "sp.birthDate": "Date de naissance",
  "sp.enrolledOn": "Inscrit le",
  "sp.blockedTitle": "Encaissement bloqué",
  "sp.blockedBody":
    "Plus de sept jours sans synchronisation. Synchronisez avant d'accepter un paiement.",
  "sp.storageBlockedTitle": "Stockage sécurisé requis",
  "sp.storageBlockedBody":
    "Le navigateur n’a pas encore accordé le stockage persistant. Installez l’application ou autorisez le stockage du site, puis resynchronisez.",
  "sp.clockBlockedTitle": "Horloge de l’appareil à vérifier",
  "sp.clockBlockedBody":
    "Impossible de vérifier l’heure de cet appareil. Activez la date et l’heure automatiques, puis resynchronisez.",
  "sp.syncNow": "Synchroniser",
  "sp.step1Body":
    "Sélectionnez les mois ou les frais d'inscription à régler. Le montant affiché est le reste dû par période.",
  "sp.step2Body":
    "Ajustez le montant alloué à chaque période en cas de paiement partiel. Le total doit rester égal au montant reçu.",
  "sp.quickSelect": "Sélection rapide :",
  "sp.allOverdue": "Tous les arriérés",
  "sp.clear": "Tout désélectionner",
  "sp.period": "Période",
  "sp.remaining": "Reste dû",
  "sp.allocated": "Alloué",
  "sp.total": "Total",
  "sp.valid": "Montants cohérents",
  "sp.invalid": "Le total ne correspond pas",
  "sp.chequeNumber": "N° de chèque",
  "sp.bank": "Banque",
  "sp.drawer": "Tireur",
  "sp.sender": "Émetteur",
  "sp.transferRef": "Référence du virement",
  "sp.transferDate": "Date du virement",
  "sp.receivedDate": "Date de réception",
  "sp.note": "Note",
  "sp.optional": "facultatif",
  "sp.backdatedTitle": "Date antérieure — motif obligatoire",
  "sp.backdatedPlaceholder": "Motif de la date antérieure",
  "sp.confirmTitle": "Confirmer le paiement",
  "sp.confirmSub": "vérifiez avant émission",
  "sp.student": "Élève",
  "sp.periods": "Périodes",
  "sp.obligationsPaid": "Obligations payées",
  "sp.method": "Mode",
  "sp.immutableWarn":
    "Après confirmation, le paiement n'est plus modifiable. Seule l'annulation est possible et laisse une trace définitive.",
  "sp.receiptIssued": "Reçu délivré",
  "sp.receiptIssuedSub": "Espèces — reçu prêt à imprimer et à remettre.",
  "sp.provIssued": "Accusé provisoire délivré",
  "sp.provIssuedSub": "En attente d'encaissement validé par l'administrateur.",
  "sp.docReceipt": "REÇU",
  "sp.docProvisional": "ACCUSÉ PROVISOIRE",
  "sp.docFixedNote": "La mise en page et les mentions du document suivent le modèle officiel.",
  "sp.print": "Imprimer",
  "sp.download": "Télécharger",
  "sp.shareGuardian": "Partager au tuteur",
  "sp.provTitle": "Accusé provisoire, pas un reçu",
  "sp.provBody": "Chèques et virements ne donnent un reçu définitif qu'après encaissement.",
  "sp.provNote":
    "L'accusé porte le badge « en attente » et figure dans la file des chèques jusqu'à validation.",
  "sp.queuedTitle": "Paiement en file d'envoi",
  "sp.queuedBody": "Enregistré localement, il partira automatiquement à la reconnexion.",
  "sp.queuedNote":
    "Le reçu s'imprime immédiatement avec sa référence définitive ; le badge passe de « en file » à « envoyé » sans intervention.",
  "sp.back": "Retour",
  "sp.next": "Suivant",
  "sp.confirmPay": "Confirmer et émettre",
  "sp.finish": "Fermer",
  "sp.runningTotal": "Total en cours",
  "sp.stepA": "Périodes",
  "sp.stepB": "Répartition",
  "sp.stepC": "Mode de paiement",
  "sp.stepD": "Confirmation",
  "sp.stepE": "Document",
  "sp.identity": "Identité",
  "sp.enrollment": "Inscription & services",
  "sp.nameAr": "Nom en arabe",
  "sp.nameFr": "Nom en français",
  "sp.cancel": "Annuler",
  "sp.computedMonthly": "Mensualité calculée",
  "sp.saveStudent": "Enregistrer l'élève",
  "sp.dupTitle": "Un élève porte déjà ce code MASSAR",
  "sp.dupBody": "Vérifiez avant de continuer : un doublon casse l'échéancier.",
  "sp.openExisting": "Ouvrir la fiche existante",
  "sp.saveAnyway": "Enregistrer quand même",
  "sp.saveFailTitle": "Enregistrement impossible",
  "sp.saveFailBody":
    "Les modifications n’ont pas pu être enregistrées. Aucun changement n’a été conservé ; réessayez.",
  "sp.invalidStudentSaveBody":
    "Vérifiez les champs obligatoires, la classe et l’année scolaire. Le code MASSAR est facultatif.",
  "sp.studentServiceSaveFailedBody":
    "L’inscription, les services et leurs obligations n’ont pas pu être mis à jour. Aucun changement n’a été conservé.",
  "sp.fixAndRetry": "Corriger et réessayer",
  "sp.keepDraft": "Garder le brouillon",
  "sp.invalidMassar": "Utilisez 6 à 20 lettres ou chiffres.",
  "sp.invalidBirthDate": "Choisissez une date de naissance valide.",
  "sp.invalidPhone": "Saisissez un numéro international ou marocain, par ex. 0611223344.",
  "sp.adjustFee": "Ajuster un frais",
  "sp.discount": "Remise",
  "sp.waiver": "Exonération",
  "sp.correction": "Correction",
  "sp.lifecycle": "Parcours scolaire",
  "sp.lifecycleStatus": "Statut scolaire",
  "sp.paymentStatus": "Statut de paiement",
  "sp.statusActive": "Scolarisé",
  "sp.statusWithdrawn": "Retiré",
  "sp.statusGraduated": "Diplômé",
  "sp.withdrawStudent": "Retirer l’élève",
  "sp.graduateStudent": "Diplômer l’élève",
  "sp.returnStudent": "Réinscrire l’élève",
  "sp.correctLifecycle": "Corriger la dernière action",
  "sp.lifecycleEffectiveDate": "Date d’effet de l’action",
  "sp.lifecycleReason": "Motif de l’action",
  "sp.lifecycleClass": "Niveau au retour",
  "sp.lifecycleResultingStatus": "Statut correct",
  "sp.lifecycleConfirmation":
    "J’ai vérifié l’identité de l’élève et l’impact financier, et je confirme cette action définitive.",
  "sp.lifecycleImmutable":
    "Cette action ne sera ni supprimée ni modifiée. Toute correction ultérieure sera ajoutée et liée à l’historique d’origine.",
  "sp.lifecycleFutureCancelled": "Solde des frais futurs qui sera annulé",
  "sp.lifecycleRetainedDebt": "Solde impayé qui restera dû",
  "sp.lifecyclePrepaid": "Frais futurs déjà payés conservés pour examen",
  "sp.lifecyclePendingBlock":
    "Des chèques ou virements en attente concernent des frais futurs. Encaissez-les ou rejetez-les avant de continuer.",
  "sp.lifecyclePreviewing": "Calcul de l’impact financier…",
  "sp.lifecycleHistory": "Historique du parcours",
  "sp.lifecycleNoHistory": "Aucune action antérieure.",
  "sp.lifecycleSubmit": "Confirmer l’action",
  "sp.lifecycleFailed": "L’action n’a pas été enregistrée. Rien n’a changé.",
  "sp.lifecycleCorrectionConflict":
    "Des opérations financières ultérieures empêchent cette correction. Vérifiez d’abord la fiche de l’élève.",
  "sp.lifecycleGraduationNotAllowed": "Le diplôme est réservé au dernier niveau du primaire.",
  "sp.lifecycleReturnHelp":
    "Les dettes antérieures restent dues, les mois d’absence restent annulés et les frais reprennent à la date du retour.",
  "sp.lifecycleCorrectionHelp":
    "L’action d’origine est conservée et cette correction est ajoutée comme fait lié.",
  "sp.lifecycleWithdrawalHelp":
    "Les frais dus jusqu’à la date du retrait restent exigibles ; seul le solde impayé postérieur est annulé.",
  "sp.lifecycleGraduationHelp":
    "Les frais dus jusqu’à la date du diplôme restent exigibles ; seul le solde impayé postérieur est annulé.",
  "sp.lifecycleTransport": "Transport au retour",
  "sp.lifecycleAccompaniment": "Accompagnement au retour",
  "sp.lifecycleCorrected": "Correction",
  "sp.lifecycleWithdrawal": "Retrait",
  "sp.lifecycleGraduation": "Diplôme",
  "sp.lifecycleReturn": "Retour",
  "sp.originalAmount": "MONTANT D'ORIGINE",
  "sp.newRemaining": "RESTE APRÈS AJUSTEMENT",
  "sp.adjustAmount": "Montant de l'ajustement",
  "sp.effectiveDate": "Date d'effet",
  "sp.reason": "Motif",
  "sp.adjustWarn":
    "Chaque ajustement est horodaté et signé par son auteur ; il apparaît dans la fiche élève et dans les rapports.",
  "sp.applyAdjust": "Appliquer l'ajustement",
  "sp.mSep": "Sept.",
  "sp.mOct": "Oct.",
  "sp.mNov": "Nov.",
  "sp.mDec": "Déc.",
  "sp.mJan": "Janv.",
  "sp.mFeb": "Févr.",
  "sp.mMar": "Mars",
  "sp.mApr": "Avril",
  "sp.mMay": "Mai",
  "sp.mJun": "Juin",
  "ops.schoolName": "Établissement Chams Al-Ouloum",
  "ops.mad": "MAD",
  "ops.chequesTitle": "Chèques & virements",
  "ops.pendingItems": "instruments en attente",
  "ops.pending": "En attente",
  "ops.pendingShort": "En attente",
  "ops.settled": "Encaissés",
  "ops.settledTab": "Encaissés",
  "ops.rejected": "Rejetés",
  "ops.student": "Élève",
  "ops.reference": "Référence",
  "ops.method": "Mode",
  "ops.amount": "Montant",
  "ops.date": "Date",
  "ops.status": "Statut",
  "ops.actions": "Actions",
  "ops.cheque": "Chèque",
  "ops.transfer": "Virement",
  "ops.cash": "Espèces",
  "ops.awaitingSettlement": "À encaisser",
  "ops.confirm": "Confirmer",
  "ops.confirmSettlement": "Confirmer l'encaissement",
  "ops.reject": "Rejeter",
  "ops.selectedNone": "Aucun élément sélectionné",
  "ops.queueTotal": "Total de la file :",
  "ops.settleTitle": "Confirmer l'encaissement",
  "ops.settleChequeTitle": "Confirmer le chèque",
  "ops.settleTransferTitle": "Confirmer le virement",
  "ops.settleChequeDate": "Date d'encaissement du chèque",
  "ops.settleTransferDate": "Date de confirmation du virement",
  "ops.rejectChequeDate": "Date de rejet du chèque",
  "ops.rejectTransferDate": "Date de rejet du virement",
  "ops.settleChequeReference": "Référence d'encaissement du chèque",
  "ops.settleTransferReference": "Référence bancaire du virement",
  "ops.rejectChequeReason": "Motif du rejet du chèque",
  "ops.rejectTransferReason": "Motif du rejet du virement",
  "ops.statementDate": "Date du relevé",
  "ops.statementRef": "Référence du relevé",
  "ops.optional": "facultatif",
  "ops.cancel": "Annuler",
  "ops.settleNote":
    "Après confirmation, l'accusé provisoire devient un reçu définitif et l'échéancier de l'élève est mis à jour.",
  "ops.settleChequeNote":
    "Après confirmation, le chèque est marqué comme encaissé, l'accusé provisoire devient un reçu définitif et l'échéancier de l'élève est mis à jour.",
  "ops.settleTransferNote":
    "Après confirmation, le virement est marqué comme reçu, l'accusé provisoire devient un reçu définitif et l'échéancier de l'élève est mis à jour.",
  "ops.rejectTitle": "Rejeter l'instrument",
  "ops.rejectChequeTitle": "Rejeter le chèque",
  "ops.rejectTransferTitle": "Rejeter le virement",
  "ops.rejectSub": "chèque sans provision ou virement non reçu",
  "ops.rejectReason": "Motif du rejet",
  "ops.confirmReject": "Confirmer le rejet",
  "ops.queueEmpty": "Rien en attente",
  "ops.queueEmptyBody": "Tous les chèques et virements sont encaissés.",
  "ops.settledEmpty": "Rien d'encaissé",
  "ops.settledEmptyBody": "Aucun chèque ou virement n'a encore été encaissé.",
  "ops.settleFailed": "Encaissement non enregistré",
  "ops.settleChequeFailed": "Encaissement du chèque non enregistré",
  "ops.settleTransferFailed": "Confirmation du virement non enregistrée",
  "ops.rejectChequeFailed": "Rejet du chèque non enregistré",
  "ops.rejectTransferFailed": "Rejet du virement non enregistré",
  "ops.settleFailedBody": "Le serveur n'a pas répondu. Rien n'a changé.",
  "ops.retry": "Réessayer",
  "ops.docReceipt": "REÇU",
  "ops.docFixedNote": "La mise en page et les mentions suivent le modèle officiel.",
  "ops.receiptLanguage": "Langue du reçu",
  "ops.print": "Imprimer",
  "ops.download": "Télécharger",
  "ops.guardianLink": "Lien tuteur",
  "ops.copy": "Copier",
  "ops.whatsapp": "WhatsApp",
  "ops.regenerate": "Régénérer",
  "ops.revoke": "Révoquer",
  "ops.linkNote":
    "Le lien n'affiche que le reçu et reste valable jusqu'à révocation ou régénération. Une régénération invalide immédiatement le précédent.",
  "ops.cancelPayment": "Annuler le paiement",
  "ops.cancelTitle": "Annulation définitive",
  "ops.cancelWarn":
    "Une annulation est irréversible. Le paiement reste au registre avec le badge « annulé » et les périodes redeviennent dues.",
  "ops.cancelDate": "Date d'annulation",
  "ops.cancelReason": "Motif de l'annulation",
  "ops.confirmCancellationCheck":
    "Je comprends que l’annulation du paiement est définitive et irréversible.",
  "ops.keepPayment": "Conserver",
  "ops.confirmCancel": "Annuler définitivement",
  "ops.cancelled": "Annulé",
  "ops.cancelledOn": "Annulé le",
  "ops.cancelledBy": "Par",
  "ops.cancelledReasonSample": "Erreur d'élève — montant restitué en espèces le 07/02/2026.",
  "ops.viewDocument": "Voir le document",
  "ops.shareDisabled": "Partage désactivé",
  "ops.reports": "Rapports",
  "ops.daily": "Journalier",
  "ops.monthly": "Mensuel",
  "ops.generate": "Générer",
  "ops.dailyReport": "Rapport journalier",
  "ops.generating": "Génération du rapport…",
  "ops.receiptsIssued": "REÇUS ÉMIS",
  "ops.cashTaken": "ESPÈCES REÇUES",
  "ops.cancelledToday": "ANNULÉS AUJOURD'HUI",
  "ops.noMovements": "Aucun mouvement sur la période",
  "ops.noMovementsBody": "Choisissez une autre date ou passez au rapport mensuel.",
  "ops.reportFailed": "Génération impossible",
  "ops.reportFailedBody": "Délai serveur dépassé. Réessayez.",
  "ops.authenticationFailedBody": "La session en ligne a expiré. Reconnectez-vous puis réessayez.",
  "ops.authorizationFailedBody":
    "Cet appareil n’est pas autorisé pour cette demande. Vérifiez son autorisation puis réessayez.",
  "ops.networkFailedBody":
    "Le serveur est actuellement inaccessible. Vérifiez la connexion puis réessayez.",
  "ops.serverFailedBody":
    "Le serveur a rencontré une erreur pendant le traitement. Réessayez dans un instant.",
  "ops.responseFailedBody": "La réponse du serveur n’a pas pu être lue. Réessayez.",
  "ops.settings": "Paramètres",
  "ops.account": "COMPTE",
  "ops.roleAdmin": "Administrateur système",
  "ops.accessCodes": "CODES D'ACCÈS",
  "ops.deviceRequests": "DEMANDES D'APPAREILS",
  "ops.deviceRequestsEmpty": "Aucun appareil enregistré.",
  "ops.deviceRequestDevice": "Appareil",
  "ops.deviceRequestAt": "Demande reçue",
  "ops.deviceDecision": "Décision",
  "ops.deviceRequestApprove": "Autoriser",
  "ops.deviceRequestReject": "Refuser",
  "ops.deviceRequestRevoke": "Révoquer",
  "ops.deviceRevokeConfirm": "Révoquer immédiatement l’autorisation de cet appareil ?",
  "ops.deviceStatusPending": "En attente",
  "ops.deviceStatusAuthorized": "Autorisé",
  "ops.deviceStatusRejected": "Refusé",
  "ops.deviceStatusRevoked": "Révoqué",
  "ops.forUser": "Utilisateur",
  "ops.purpose": "Objet",
  "ops.purposePasskey": "Enregistrement de clé",
  "ops.expiresIn": "Expire dans",
  "ops.codeOnceNote":
    "Le code s'affiche une seule fois. S'il est perdu, générez-en un nouveau : l'ancien est invalidé.",
  "ops.systemStatus": "ÉTAT DU SYSTÈME",
  "ops.service": "Service",
  "ops.worker": "Tâches de fond",
  "ops.workerLate": "dernière exécution il y a 41 min",
  "ops.lastSync": "Dernière sync.",
  "ops.bannerOffline": "Vous travaillez hors ligne — l'encaissement reste autorisé",
  "ops.bannerSyncFailed": "Synchronisation échouée",
  "ops.bannerSyncFailedBody": "Les paiements en file n'ont pas été envoyés. Aucune donnée perdue.",
  "ops.bannerUpdate": "Mise à jour prête",
  "ops.bannerUpdateBody": "Le redémarrage prend quelques secondes, sans perte de données.",
  "ops.restartNow": "Redémarrer",
  "ops.bannerUpdateAfterSync": "Mise à jour après synchronisation",
  "ops.bannerUpdateAfterSyncBody":
    "Des paiements attendent leur envoi ; le redémarrage patientera.",
  "ops.genericEmpty": "Rien ici pour l'instant",
  "ops.genericEmptyBody": "Dès la première opération, elle apparaîtra dans cette liste.",
  "ops.genericError": "Une erreur est survenue",
  "ops.genericErrorBody": "Cette section n'a pas pu être chargée. Le reste de la page fonctionne.",
  "ops.ladder1": "Tout va bien. Un petit point vert dans le bandeau, rien d'autre.",
  "ops.ladder2":
    "Point ambre et avertissement discret, uniquement dans le panneau de synchronisation.",
  "ops.ladder3":
    "Encaissement bloqué : bandeau rouge, bouton désactivé, invitation explicite à synchroniser.",
  "ops.ladderOfflineTitle": "Hors ligne",
  "ops.ladder4":
    "Les chiffres calculés côté serveur sont indisponibles ; l'encaissement fonctionne et reste local.",
} as const satisfies Record<MessageKey, string>;

export const catalogues: Record<Locale, Record<MessageKey, string>> = { ar, fr };

let productName = "Chams.Pay";

export function configureTranslationProductName(value: string): void {
  if (value.trim()) productName = value.trim();
}

export function translate(locale: Locale, key: MessageKey): string {
  return catalogues[locale][key].replaceAll("Chams.Pay", productName);
}

export function directionFor(locale: Locale): "rtl" | "ltr" {
  return locale === "ar" ? "rtl" : "ltr";
}
